// AUTO-GENERATED from /app/backend/uploads/imports/translation_review_revised.xlsx
// Regenerate via: python3 /app/backend/scripts/apply_translations.py

export const translations = {
  en: {
  "nav": {
    "home": "Home",
    "catalogue": "Partner brands",
    "specials": "Special Offers",
    "plans": "Plans",
    "how": "FAQ",
    "blog": "Blog",
    "about": "About",
    "faq": "FAQ",
    "contact": "Contact",
    "cta": "Register",
    "consult": "Schedule Free Consultation",
    "simple": {
      "aboutUs": "About Us",
      "how": "How it works",
      "register": "Registration",
      "consult": "Book Consultation",
      "brands": "Partner Brands",
      "feeder": "SmartPaw Feeder",
      "experts": "Our Experts",
      "contact": "Contacts",
      "home": "Home",
      "menu": "Menu",
      "closeMenu": "Close",
      "scrollDown": "Explore more"
    }
  },
  "common": {
    "startPlan": "Start free",
    "talkToUs": "Talk to us",
    "openWhatsApp": "Open WhatsApp",
    "askWhatsApp": "Ask on WhatsApp",
    "chatWhatsApp": "Chat on WhatsApp",
    "stillStuck": "Still stuck? WhatsApp us",
    "read": "Read",
    "readMore": "Read more",
    "loading": "Loading…",
    "tryAgain": "Please try again.",
    "backToBlog": "Back to blog",
    "sending": "Sending…",
    "yes": "Yes",
    "no": "No",
    "included": "Included",
    "notIncluded": "Not included",
    "new": "New"
  },
  "hero": {
    "eyebrow": "Tbilisi · Free delivery",
    "titleA": "Get much more —",
    "titleB": "for the price of products only.",
    "sub": "Register and have fun with your four-legged friend — SmartPaw takes care of the rest.",
    "ctaPrimary": "Register",
    "ctaConsult": "Book a consultation",
    "ctaWhatsapp": "Message us on WhatsApp",
    "ctaSecondary": "Partner brands",
    "ctaSpecials": "Special Offers",
    "stat1": "Free Delivery on any quantity",
    "stat2": "Individual Consultations from our Experts",
    "stat3": "No Shortages",
    "stat4": "Never Forget",
    "feederLine": "",
    "feederBadge": "SmartPaw Feeder"
  },
  "consult": {
    "title": "Book a consultation",
    "subtitle": "Leave your name and phone — a SmartPaw expert will call you back.",
    "name": "Name",
    "phone": "Phone",
    "time": "Preferred time (optional)",
    "timePlaceholder": "e.g. Mon-Fri 18:00-20:00",
    "note": "What would you like to discuss?",
    "submit": "Request a call",
    "cancel": "Cancel",
    "thanksTitle": "Got it!",
    "thanksBody": "We'll call you back during working hours."
  },
  "aboutUs": {
    "eyebrow": "About Us",
    "title": "Built in Tbilisi, by pet parents.",
    "body": "SmartPaw was born from a simple frustration — late-night shop runs, forgotten food bags and feeders that just don't fit a real schedule. We pair vet-approved brands with a smart feeder and door-to-door delivery, so your pet's routine runs itself.",
    "teamTitle": "People behind SmartPaw"
  },
  "consultSection": {
    "eyebrow": "Free consultation",
    "title": "Not sure which plan or brand fits your pet?",
    "body": "Book a free 15-minute call with a SmartPaw expert. We'll help you pick the right food, portion and schedule — no commitment, no pressure.",
    "cta": "Book a free consultation"
  },
  "feeder": {
    "eyebrow": "",
    "title": "A device that helps you keep a consistent feeding routine — even when you are not home.",
    "lead": "We programme the exact times and portions together, and the feeder feeds your pet reliably — even when you are not at home.",
    "bullet1": "Automatic portions on the schedule you set",
    "bullet2": "Runs on both mains power and batteries",
    "bullet3": "Quiet, pet-safe mechanism",
    "bullet4": "We handle the programming, keep it stocked with food and look after technical upkeep.",
    "cta": "Book a consultation"
  },
  "experts": {
    "eyebrow": "",
    "title": "Individual consultations for every SmartPaw member.",
    "name": "Giorgi Kobakhidze",
    "role": "Cynologist · Nutrition expert",
    "bio": "A cynologist and animal-care expert with years of hands-on nutrition work. Giorgi helps SmartPaw members pick the right food, dial in portions, manage allergies and fine-tune every pet's routine.",
    "benefitsTitle": "What every SmartPaw member gets:",
    "bullet1": "Regular, no-charge consultations — included with every plan",
    "bullet2": "Personalised food and portion advice",
    "bullet3": "Tailored care and behaviour advice built around your pet",
    "bullet4": "Schedule tune-ups as your pet grows",
    "cta": "Book a free consultation"
  },
  "signup": {
    "title": "Start with SmartPaw",
    "subtitle": "Fill in a few details and our managers will call you to finalise your registration.",
    "nameLabel": "Name",
    "surnameLabel": "Surname",
    "phoneLabel": "Phone Number",
    "addressLabel": "Address",
    "petTypeLabel": "Pet Type",
    "petNameLabel": "Pet Name",
    "petTypeDog": "Dog",
    "petTypeCat": "Cat",
    "petTypeOther": "Other",
    "namePh": "e.g. Nino",
    "surnamePh": "e.g. Beridze",
    "phonePh": "+995 ...",
    "addressPh": "City, street, apt",
    "petNamePh": "e.g. Simba",
    "submit": "Submit application",
    "sending": "Sending…",
    "errorRequired": "Please fill in all required fields.",
    "errorNetwork": "Something went wrong. Please try again.",
    "thanksTitle": "Your application is received",
    "thanksBody": "Our managers will contact you shortly to finalise registration.",
    "thanksClose": "Close"
  },
  "contactSection": {
    "eyebrow": "Contact",
    "title": "Say hello.",
    "body": "WhatsApp is the fastest way to reach us. Email works too — we reply within a few hours during working days.",
    "addressLabel": "Address",
    "phoneLabel": "Phone / WhatsApp",
    "emailLabel": "Email",
    "hoursLabel": "Hours",
    "waCta": "Message us on WhatsApp"
  },
  "pricing": {
    "title": "Packages",
    "col1Title": "Partner brands",
    "col1Price": "0 ₾",
    "col1Body": "Service and delivery are free. You pay only for the products.",
    "col2Badge": "Most popular",
    "col2Title": "150 ₾+ a month",
    "col2Price": "+ free Feeder",
    "col2Body": "Delivery, setup and programming included.",
    "col3Title": "SmartPaw Feeder",
    "col3Price": "Free",
    "col3Body": "With 150 ₾+ monthly orders. Delivery, setup and pickup if you cancel — all included.",
    "col4Title": "Other brands",
    "col4Price": "15 ₾ / month",
    "col4Body": "If your product isn't in our catalogue.",
    "fullDetails": "Full details →"
  },
  "referrals": {
    "eyebrow": "Refer a friend",
    "title": "Share SmartPaw with another pet parent",
    "body": "Introduce a friend — when they place their first order, you both get 20 ₾ credit toward your next delivery.",
    "cta": "Share on WhatsApp",
    "waText": "Hey! I use SmartPaw to get my pet's food delivered on a schedule — same prices, free delivery. Try it: https://smartpaw.ge"
  },
  "faq": {
    "eyebrow": "FAQ",
    "title": "Frequently asked questions",
    "seeMore": "See more",
    "seeLess": "See less",
    "items": [
      { "q": "How does the subscription work?", "a": "You pick products once, set the frequency (weekly / every 2 weeks / monthly), and we deliver on schedule. Pause or change anytime." },
      { "q": "Are the prices the same as in the pet store?", "a": "Yes — you pay the same price as in our partner stores. Delivery is on us." },
      { "q": "Can I pause or cancel at any time?", "a": "Of course — change your plan or cancel from your cabinet, no questions asked. If you have the Feeder, we'll pick it up for free." },
      { "q": "Which districts do you cover?", "a": "All of Tbilisi. If you're outside Tbilisi, message us on WhatsApp — we're expanding." },
      { "q": "What if my preferred brand isn't on the list?", "a": "We can source most pet brands for a 15 ₾/month service fee. Just mention it in the signup form." },
      { "q": "How do I get support?", "a": "Message us on WhatsApp at +995 591 96 99 01 — we reply within 2 hours during working hours (Mon-Sat · 09:00-19:00)." }
    ]
  },
  "care": {
    "title": "SmartPaw Care: 8 feeding points for Tbilisi's stray animals.",
    "link": "Learn more ↗"
  },
  "ctaBand": {
    "question": "Never want to visit a pet shop again?",
    "cta": "Start free"
  },
  "partners": {
    "eyebrow": "",
    "heading": "300+ Brands Trust Us",
    "viewAll": "See all brands"
  },
  "quote": {
    "eyebrow": "Get started in 1 minute",
    "title": "Get started in 1 minute",
    "subtitle": "We'll reply on WhatsApp within 2 hours during working hours.",
    "bullet1": "Free delivery",
    "bullet2": "Pause or change anytime",
    "bullet3": "120+ Tbilisi households",
    "name": "Name",
    "phone": "Phone",
    "email": "Email",
    "petType": "Pet",
    "petName": "Pet's name",
    "age": "Age (years)",
    "weight": "Weight (kg)",
    "breed": "Breed",
    "brand": "Preferred brand",
    "city": "District",
    "notes": "Notes",
    "moreDetails": "+ Add details (optional)",
    "submit": "Send",
    "disclaimer": "We reply within 2 hours during working hours.",
    "thanksTitle": "Thank you, {name}!",
    "thanksBody": "We'll message you on WhatsApp shortly.",
    "thanksCta": "Message us now",
    "recommend": "Not sure / recommend"
  },
  "team": {
    "eyebrow": "Our Team",
    "title": "The people behind SmartPaw",
    "subtitle": "Practical experience across pet care, business, and innovation."
  },
  "products": {
    "regular": {
      "eyebrow": "What we deliver",
      "title": "What we deliver",
      "body": "",
      "notice": "",
      "items": [
        {
          "key": "food",
          "title": "Food",
          "desc": "Dry kibble, wet food and treats from trusted brands."
        },
        {
          "key": "hygiene",
          "title": "Hygiene",
          "desc": "Shampoos, litter, wipes and grooming basics."
        },
        {
          "key": "vitamins",
          "title": "Vitamins & Additives",
          "desc": "Supplements, probiotics and dietary boosters."
        }
      ]
    },
    "specials": {
      "eyebrow": "Special Offers",
      "title": "",
      "body": "Get special prices and conditions from our partners.",
      "notice": "",
      "items": [
        {
          "key": "toys",
          "title": "Toys & Accessories",
          "desc": "Collars, leashes, beds, toys and seasonal picks."
        },
        {
          "key": "tech",
          "title": "Innovation & Tech",
          "desc": "Smart feeders, paw-cams and connected devices."
        },
        {
          "key": "services",
          "title": "Services",
          "desc": "Grooming, vet check-ups and home visits."
        }
      ]
    }
  },
  "features": {
    "f1": {
      "kicker": "Vet-approved brands",
      "title": "A shelf curated by people who actually know pets.",
      "body": "Premium dog food, cat food, treats, supplements. Keep what works, swap what doesn’t — we restock automatically every cycle.",
      "cta": "Browse catalogue"
    },
    "f2": {
      "kicker": "Door to door",
      "title": "We schedule the drop. You skip the run.",
      "body": "Door-to-door across every Tbilisi district, included with every plan — no minimum-order tax, no surprise fees. Same-day for orders placed before noon.",
      "cta": "Talk to us"
    },
    "f3": {
      "kicker": "Tuned to your pet",
      "title": "Built around your dog or cat — not a generic plan.",
      "body": "Tell us your pet’s breed, age and eating habits once. We tune bag size, swap rate and hygiene cadence so the next box arrives ready, not approximate.",
      "cta": "Read the blog"
    },
    "f4": {
      "kicker": "Dogs + cats both",
      "title": "Every life stage, every dietary need.",
      "body": "Senior-formula kibble, puppy starter packs, sensitive-stomach lines, hypoallergenic options — dogs and cats. The plan grows when your pet does.",
      "cta": "Open shop"
    }
  },
  "why": {
    "eyebrow": "Why SmartPaw",
    "title": "Importance of Routine Feeding",
    "body": "Leading veterinary bodies agree: feeding on a schedule is a core part of preventive care. The American Animal Hospital Association (AAHA) recommends that frequency, timing and portion of feeding be assessed at every visit, because consistent meals make it easier to control calorie intake, maintain healthy body condition, and spot appetite changes — often the earliest sign that something is wrong.",
    "bodyCite": "Source: AAHA Nutrition & Weight Management Guidelines (2021).",
    "badges": [
      "Free Regular Delivery",
      "Free Food Dispenser",
      "Regular Reminders",
      "Stock Management"
    ]
  },
  "how": {
    "eyebrow": "How it works",
    "title": "How it works",
    "body": "",
    "cta": "Sign up",
    "steps": [
      { "n": "01", "t": "Click Register", "d": "Fill in a simple form." },
      { "n": "02", "t": "Tell us about your pet", "d": "Species, age, weight — and anything else we should know." },
      { "n": "03", "t": "Pick products, quantity & frequency", "d": "From 300+ brands, or let us recommend." },
      { "n": "04", "t": "Enjoy — we handle the rest", "d": "We track consumption and refill before you run out — on time, every time." }
    ]
  },
  "howPage": {
    "timelineEyebrow": "Step by step",
    "timelineTitle": "What happens from signup to second delivery.",
    "timelineIntro": "We built SmartPaw around what Tbilisi pet parents actually told us: too many shop runs, too many ‘out of stock’ messages, too many feeders that fight the routine instead of supporting it. Here is the workflow we run for every customer — predictable, honest and human.",
    "timeline": [
      {
        "title": "Tell us about your pet",
        "body": "A 2-minute form: species, breed, age, weight, sensitivities and the routine you keep today. We use it to size portions and pre-pick a shelf that fits.",
        "bullets": [
          "Pet profile + photo (optional)",
          "Dietary notes & allergies",
          "Your district in Tbilisi"
        ]
      },
      {
        "title": "We curate the shelf",
        "body": "Our team matches your profile with vet-aligned brands. You see exactly what is going in the box — swap anything, lock anything in.",
        "bullets": [
          "Vet-recommended brand match",
          "Food + hygiene + treats bundle",
          "You approve before first ship"
        ]
      },
      {
        "title": "Choose your cadence",
        "body": "Weekly, bi-weekly or monthly. Pick a delivery window that fits your week — we lock it in and keep it predictable.",
        "bullets": [
          "Weekly · bi-weekly · monthly",
          "Pick a 2-hour delivery window",
          "Pause or skip any time"
        ]
      },
      {
        "title": "We deliver — door to door",
        "body": "Same courier where possible, so your dog stops barking at the doorbell. Contact-free, signed receipts, and a heads-up an hour before arrival.",
        "bullets": [
          "Free delivery on every plan",
          "WhatsApp on-the-way alert",
          "Leave-at-door if you prefer"
        ]
      },
      {
        "title": "Adjust anytime",
        "body": "Pet on a new diet? Travelling? Just say the word. Skip a delivery, swap a brand, change the cadence — no fees, no friction.",
        "bullets": [
          "Brand swap, no charge",
          "Skip / pause from WhatsApp",
          "Profile updates anytime"
        ]
      },
      {
        "title": "A team that picks up",
        "body": "A real human on the other end. We answer WhatsApp during opening hours and remember your pet by name on the second message.",
        "bullets": [
          "WhatsApp, not chatbots",
          "Local Tbilisi team",
          "1-hour median reply time"
        ]
      }
    ],
    "faqEyebrow": "Quick answers",
    "faqTitle": "Before you sign up.",
    "faqs": [
      {
        "q": "How long does signup take?",
        "a": "About two minutes. You tell us about your pet, pick a cadence, and we send a tailored quote on WhatsApp — usually within the hour."
      },
      {
        "q": "Do I have to commit to a contract?",
        "a": "No. Every plan is month-to-month. Pause, skip or cancel any time — no questions and no exit fees."
      },
      {
        "q": "What happens if my pet doesn’t like a product?",
        "a": "Tell us on WhatsApp and we’ll swap it on your next delivery at no extra cost. We track what your pet actually eats and refine over time."
      },
      {
        "q": "Is delivery really free?",
        "a": "Yes, on every plan, in every district of Tbilisi. There are no minimum-order fees and no fuel surcharges."
      },
      {
        "q": "Can I get a SmartPaw Feeder without the box?",
        "a": "The Feeder is part of the 150 GEL/month plan — see the Plans page for the breakdown. It ships free once the plan is active."
      }
    ]
  },
  "plans": {
    "eyebrow": "Plans & Pricing",
    "title": "Three plans. Pick the routine that fits.",
    "intro": "Tailored boxes for Tbilisi pet parents. Start free with delivery only, unlock the SmartPaw Feeder for free with a 150 GEL/month plan, or design a custom shelf for a flat 15 GEL delivery fee.",
    "badgePopular": "Most popular",
    "pricePer": "/ month",
    "flatFee": "flat fee per delivery",
    "pickThis": "Pick this plan",
    "pickFeeder": "Pick Feeder plan",
    "customPlan": "Build my custom plan",
    "inclEyebrow": "What’s included",
    "everythingIn": "Everything in:",
    "tiers": [
      {
        "key": "free",
        "eyebrow": "Starter",
        "name": "SmartPaw Free",
        "price": "0 GEL",
        "priceNote": "You only pay for products.",
        "tagline": "A no-commitment way to try us out.",
        "features": [
          "Free door-to-door delivery in Tbilisi",
          "Reminders for refills and renewals",
          "No minimum order, no contracts",
          "Pause, skip or cancel any time"
        ],
        "cta": "Start free"
      },
      {
        "key": "feeder",
        "eyebrow": "Best value",
        "name": "Free + SmartPaw Feeder",
        "price": "150 GEL",
        "priceNote": "Minimum monthly spend.",
        "tagline": "Routine on autopilot — feeder included.",
        "features": [
          "Everything in SmartPaw Free",
          "Free SmartPaw smart feeder (worth ~300 GEL)",
          "Auto-portioned meals, even when you’re out",
          "Priority WhatsApp support"
        ],
        "cta": "Get the feeder"
      },
      {
        "key": "custom",
        "eyebrow": "Pay-per-drop",
        "name": "Custom Delivery",
        "price": "15 GEL",
        "priceNote": "Flat fee per delivery — no subscription.",
        "tagline": "Need a one-off or off-cycle shipment?",
        "features": [
          "No monthly minimum",
          "Order exactly what you need, when you need it",
          "Same-day if you order before noon",
          "Switch to a plan any time"
        ],
        "cta": "Build custom order"
      }
    ],
    "compareEyebrow": "Side by side",
    "compareTitle": "Compare the three plans.",
    "compareFeatureCol": "Feature",
    "compareRows": [
      {
        "feature": "Free delivery in Tbilisi",
        "values": [
          "True",
          "True",
          "15 GEL flat"
        ]
      },
      {
        "feature": "Monthly minimum",
        "values": [
          "None",
          "150 GEL",
          "None"
        ]
      },
      {
        "feature": "Free SmartPaw Feeder",
        "values": [
          "False",
          "True",
          "False"
        ]
      },
      {
        "feature": "Refill reminders",
        "values": [
          "True",
          "True",
          "True"
        ]
      },
      {
        "feature": "Brand swap on request",
        "values": [
          "True",
          "True",
          "True"
        ]
      },
      {
        "feature": "Priority WhatsApp support",
        "values": [
          "False",
          "True",
          "False"
        ]
      },
      {
        "feature": "Pause, skip or cancel anytime",
        "values": [
          "True",
          "True",
          "—"
        ]
      },
      {
        "feature": "Best for",
        "values": [
          "Trying us out",
          "Long-term care",
          "One-off orders"
        ]
      }
    ],
    "servicesEyebrow": "Shared on every plan",
    "servicesTitle": "Add-on services, on every tier.",
    "servicesBody": "These are available to anyone on any plan. We schedule them around your delivery cadence and bill per visit — no subscription, no markup.",
    "servicesCta": "See all services",
    "services": [
      {
        "title": "Grooming",
        "body": "Bath, brush and nail trim with a vetted local groomer — at your door or in our partner studio."
      },
      {
        "title": "Vet check-ups",
        "body": "Annual and seasonal vet visits with our partner clinics, with vaccination reminders built in."
      },
      {
        "title": "Home visits",
        "body": "Pet sitter check-ins while you’re travelling. Twice-daily feed, walk and a photo update."
      }
    ],
    "footnote": "Final terms (minimum monthly spend, feeder return policy and service pricing) are confirmed on signup. Need a custom set-up? Message us on WhatsApp."
  },
  "about": {
    "eyebrow": "About",
    "title": "Smart care. Real impact.",
    "intro": "SmartPaw was built in Tbilisi by pet parents who got tired of late-night shop runs, forgotten food bags and feeders that just don’t fit a real schedule. We pair vet-approved brands with a free SmartPaw Feeder and door-to-door delivery — so the routine actually runs itself.",
    "founderEyebrow": "Founder story",
    "founderTitle": "Built for Tbilisi pet parents, by one of them.",
    "founderParas": [
      "SmartPaw started, like most things you actually need, with a problem nobody was solving cleanly. Our founder, Tornike, has two dogs — Buba and Ruka — and a habit of remembering the kibble bag is empty around 10pm on a Tuesday. Every. Single. Time.",
      "He tried the local pet shops, the imported brands and the bigger chains. The brands were fine. The routine was the problem. Late-night dashes, forgotten orders, ‘out of stock’ messages two weeks in a row, feeders sold by people who had never owned a pet.",
      "So we built the thing we wanted ourselves. **A subscription where vet-approved food just shows up.** A SmartPaw Feeder that portions meals automatically and ships free with eligible plans. Delivery that is genuinely free, every district in Tbilisi. And a team you can WhatsApp like you’d WhatsApp a friend."
    ],
    "founderQuote": "\"If your pet has a routine, your shopping shouldn’t need one.\"",
    "metrics": [
      {
        "value": "1,200+",
        "label": "Pets fed monthly"
      },
      {
        "value": "36",
        "label": "Curated SKUs on shelf"
      },
      {
        "value": "< 60 min",
        "label": "WhatsApp median reply"
      },
      {
        "value": "0 GEL",
        "label": "Delivery fee, every plan"
      }
    ],
    "valuesEyebrow": "What we stand for",
    "valuesTitle": "Four things we don’t compromise on.",
    "values": [
      {
        "title": "Vet-aligned",
        "body": "Every brand on the shelf is one a Tbilisi vet would recommend — no diet fads, no gimmicks, no ‘grain-free because it sounds clean’."
      },
      {
        "title": "Honest pricing",
        "body": "No hidden fees, no minimum-order tax, no fuel surcharge. The price you sign up at is the price you keep."
      },
      {
        "title": "Tbilisi roots",
        "body": "Locally founded, locally delivered. We answer the WhatsApp, we know the districts, and we know your dog by name on the second message."
      },
      {
        "title": "Quietly modern",
        "body": "A free SmartPaw Feeder, a self-managed schedule and a team that actually picks up. Modern enough to feel effortless, calm enough to stay invisible."
      }
    ],
    "teamEyebrow": "The team",
    "teamTitle": "Small team. Big on follow-through.",
    "teamIntro": "Four people pick the shelf, run the routes and answer your WhatsApp. No call-centres, no scripted replies — just a Tbilisi crew that lives with pets too.",
    "team": [
      {
        "name": "Tornike K.",
        "role": "Founder & Routine Designer",
        "bio": "Spent ten years in product, two dogs in. Started SmartPaw after one too many 10pm runs for kibble."
      },
      {
        "name": "Nina G.",
        "role": "Head of Vet Partnerships",
        "bio": "Veterinary nurse turned brand-curator. Vets every shelf before it ships and runs our nutrition help-desk."
      },
      {
        "name": "Luka B.",
        "role": "Operations & Delivery",
        "bio": "Maps every Tbilisi district by mood. If you have ever lived in Saburtalo, you understand the value."
      },
      {
        "name": "Mariam T.",
        "role": "Customer Care · WhatsApp Lead",
        "bio": "The voice on the other end of your WhatsApp. Remembers pets by name, knows when to send a Tuesday reminder."
      }
    ],
    "midCtaEyebrow": "Routine starts here",
    "midCtaTitle": "Want a quote that fits your pet, your district and your week?"
  },
  "contact": {
    "eyebrow": "Contact",
    "title": "Let’s talk pet routines.",
    "intro": "",
    "address": "Address",
    "addressValue": "0102 Tsereteli Ave. 118, Tbilisi, Georgia",
    "phone": "Phone / WhatsApp",
    "email": "Email",
    "hours": "Hours",
    "hoursValue": "Mon–Sat · 09:00–19:00",
    "hoursToConfirm": "(to confirm)",
    "sendEyebrow": "Send a message",
    "sendTitle": "For everything that isn’t a quick WhatsApp.",
    "sendBody": "",
    "topicLabel": "Topic",
    "topicOther": "Other",
    "departments": [
      {
        "key": "general",
        "title": "Customer support",
        "body": "Plan questions, deliveries, brand swaps, refunds."
      },
      {
        "key": "partnerships",
        "title": "Brand partnerships",
        "body": "Get your brand on the SmartPaw shelf or run a co-promo."
      },
      {
        "key": "press",
        "title": "Press & media",
        "body": "Interviews, founder quotes, product imagery."
      },
      {
        "key": "careers",
        "title": "Careers",
        "body": "Open roles in delivery, customer care and ops."
      }
    ],
    "form": {
      "name": "Your name",
      "namePh": "Ana Ramishvili",
      "email": "Email",
      "emailPh": "you@example.com",
      "subject": "Subject",
      "subjectPh": "What is this about?",
      "message": "Message",
      "messagePh": "Tell us what you need — the more context, the faster we reply.",
      "submit": "Send message",
      "errorRequired": "Please fill in every field before sending.",
      "errorGeneric": "Could not send your message — please try WhatsApp.",
      "success": "Got it — we’ll reply by email within one working day. For anything urgent, please WhatsApp us.",
      "routedTo": "Routed to"
    }
  },
  "faq": {
    "eyebrow": "FAQ",
    "title": "Questions, answered.",
    "intro": "The most common things Tbilisi pet parents ask us. Don’t see your question? WhatsApp us — we usually reply within the hour.",
    "searchPh": "Search the FAQs…",
    "categories": [
      {
        "key": "all",
        "label": "All"
      },
      {
        "key": "plans",
        "label": "Plans & Pricing"
      },
      {
        "key": "delivery",
        "label": "Delivery"
      },
      {
        "key": "products",
        "label": "Products & Brands"
      },
      {
        "key": "feeder",
        "label": "SmartPaw Feeder"
      },
      {
        "key": "account",
        "label": "Account & Support"
      }
    ],
    "items": [
      {
        "cat": "plans",
        "q": "How does the SmartPaw subscription work?",
        "a": "You register, pick your products and a delivery cadence (weekly, bi-weekly or monthly). We deliver to your door on schedule. You can pause, skip or change products any time."
      },
      {
        "cat": "plans",
        "q": "How much does it cost?",
        "a": "Plans start from 0 GEL/month (Free plan) up to 150 GEL/month for the Free + Feeder bundle, plus a 15 GEL flat fee on the Custom Delivery plan. See the Plans page for the full breakdown."
      },
      {
        "cat": "plans",
        "q": "Can I pause or cancel?",
        "a": "Yes — any time, no questions asked. Pause for a vacation, cancel if you move. No long contracts, no exit fees."
      },
      {
        "cat": "plans",
        "q": "Do you offer a multi-pet discount?",
        "a": "Yes — we tailor multi-pet pricing on the Custom Delivery plan. WhatsApp us with the number of pets and their profiles and we’ll send a quote."
      },
      {
        "cat": "plans",
        "q": "Can I gift a SmartPaw plan?",
        "a": "Yes. We can prepay a 1, 3 or 6-month plan as a gift — message us on WhatsApp with the recipient’s pet profile."
      },
      {
        "cat": "delivery",
        "q": "Where do you deliver?",
        "a": "Across every district in Tbilisi. We’ll expand to other Georgian cities — register to be notified when we launch in yours."
      },
      {
        "cat": "delivery",
        "q": "Is delivery really free?",
        "a": "Yes, on every plan, in every district of Tbilisi. There are no minimum-order fees and no fuel surcharges."
      },
      {
        "cat": "delivery",
        "q": "How will I know when my box is on the way?",
        "a": "You’ll get a WhatsApp message about an hour before our courier arrives, with their name and ETA. Same courier where possible, to keep things calm for your pet."
      },
      {
        "cat": "delivery",
        "q": "What if no one is home?",
        "a": "Pick a 2-hour delivery window when you sign up, or tell us to leave the box at your door — your call."
      },
      {
        "cat": "delivery",
        "q": "Can I change my delivery date?",
        "a": "Yes. Skip, delay or rush any individual delivery from WhatsApp up to 24 hours before the scheduled date."
      },
      {
        "cat": "products",
        "q": "Are your brands vet-approved?",
        "a": "Yes. Every brand on our shelf is one a Tbilisi vet would recommend — no diet fads, no gimmicks. Our Head of Vet Partnerships, Nina, reviews every shelf before it ships."
      },
      {
        "cat": "products",
        "q": "What if my pet doesn’t like a product?",
        "a": "Tell us and we’ll swap it on your next delivery at no extra cost. We track what your pet actually eats and refine the box over time."
      },
      {
        "cat": "products",
        "q": "Do you stock prescription diets?",
        "a": "Yes — renal, urinary, weight management, sensitivity and hypoallergenic lines from Royal Canin, Hill’s and Purina Pro Plan. Share the vet prescription on WhatsApp and we’ll add it to your plan."
      },
      {
        "cat": "products",
        "q": "Do you sell only food?",
        "a": "No. We also stock hygiene basics, vitamins, toys, accessories and tech. The Special Offers page has the full Toys, Innovation & Tech and Services shelves."
      },
      {
        "cat": "products",
        "q": "Where do your brands come from?",
        "a": "Most of our food and hygiene lines are sourced through official European distributors (Royal Canin, Hill’s, Acana, Orijen, Beaphar, Virbac). Tech and accessories come from authorised regional partners. Every SKU is sealed, in date, and stored in temperature-controlled warehousing."
      },
      {
        "cat": "feeder",
        "q": "What is the free SmartPaw Feeder?",
        "a": "A programmable smart feeder that portions meals automatically. It ships free with eligible plans (currently the 150 GEL/month bundle) — keep it as long as your subscription is active."
      },
      {
        "cat": "feeder",
        "q": "Who installs and sets up the Feeder?",
        "a": "Our courier sets it up on first delivery if you’d like, or you can do it yourself in about 5 minutes — every Feeder ships with a step-by-step card."
      },
      {
        "cat": "feeder",
        "q": "What happens to the Feeder if I cancel?",
        "a": "You return it on cancellation. We’ll arrange a free courier pickup on a day that suits you. No fees, no shipping charges."
      },
      {
        "cat": "feeder",
        "q": "Can I buy a SmartPaw Feeder outright?",
        "a": "Right now, the Feeder is bundled with the 150 GEL plan only. We may offer an outright purchase option later — message us if you’d like to be on the list."
      },
      {
        "cat": "account",
        "q": "How do I update my pet’s profile?",
        "a": "During launch you can WhatsApp or email any changes; a self-service customer account is on the roadmap."
      },
      {
        "cat": "account",
        "q": "Do I need to create an account?",
        "a": "No login is required to register interest or get a quote. We’ll move to full self-service accounts as we open up cart and checkout later in the year."
      },
      {
        "cat": "account",
        "q": "How do I get a refund?",
        "a": "If something arrives damaged or expired, WhatsApp us within 7 days with a photo and we’ll replace it free of charge or refund the affected items."
      },
      {
        "cat": "account",
        "q": "How quickly do you reply on WhatsApp?",
        "a": "Median reply time is under 60 minutes during opening hours (Mon–Sat, 09:00–19:00). Outside hours we reply first thing the next morning."
      }
    ],
    "emptyBody": "Try a different keyword, switch the category, or just WhatsApp us."
  },
  "blogPage": {
    "eyebrow": "From the journal",
    "title": "Real care, real reading.",
    "intro": "Short, practical reads on pet nutrition, routines and small things that make a big difference. Written for Tbilisi pet parents, reviewed by working vets.",
    "allArticles": "All articles",
    "cardRead": "Read",
    "loadError": "Couldn’t load the journal.",
    "emptyTitlePre": "Nothing tagged ",
    "emptyTitlePost": " yet.",
    "emptyBody": "Pick another tag — more articles are on the way."
  },
  "blogPost": {
    "share": "Share",
    "tags": "Tags",
    "relatedTitle": "Keep reading.",
    "ctaEyebrow": "SmartPaw Food",
    "ctaTitle": "Ready to skip the next pet-shop run?",
    "loadError": "Couldn’t load this article."
  },
  "categories": {
    "eyebrow": "What we deliver",
    "title": "One subscription, every shelf.",
    "items": [
      {
        "title": "Pet Food",
        "desc": "Dry kibble, wet food, treats."
      },
      {
        "title": "Pet Accessories",
        "desc": "Collars, leashes, beds, toys."
      },
      {
        "title": "Health & Hygiene",
        "desc": "Supplements, litter, shampoos."
      },
      {
        "title": "SmartPaw Innovation",
        "desc": "Smart dispenser, paw-cam and more."
      }
    ]
  },
  "blog": {
    "eyebrow": "From the journal",
    "title": "Real care, real reading.",
    "readAll": "Read the blog",
    "items": [
      {
        "tag": "Smart devices",
        "t": "Why regular feeding is essential — and how smart devices help",
        "d": "Routine isn’t optional for healthy pets. A look at how programmable feeders take the guesswork out of mealtimes.",
        "read": "6 min read"
      },
      {
        "tag": "Nutrition",
        "t": "Switching foods without the fuss",
        "d": "A vet-approved nine-day plan for moving onto a new diet without upsetting your pet’s stomach.",
        "read": "5 min read"
      },
      {
        "tag": "Tbilisi life",
        "t": "Indoor-cat checklist for Tbilisi apartments",
        "d": "Vertical territory, slow feeders and small daily rituals for cats who never leave the flat.",
        "read": "7 min read"
      }
    ]
  },
  "testimonials": {
    "eyebrow": "",
    "title": "The owners' top choice.",
    "subtitle": "Four quick stories from members who stopped worrying about pet food.",
    "items": [
      {
        "name": "Nino K.",
        "city": "Vake, Tbilisi",
        "pet": "Luna · British Shorthair",
        "quote": "The box arrives on time, every single time \u2014 I haven't thought about food runs in 4 months."
      },
      {
        "name": "Dato M.",
        "city": "Saburtalo, Tbilisi",
        "pet": "Rex · Labrador",
        "quote": "Giorgi's consultations are a real help \u2014 our Rex is consistently at the right, healthy weight."
      },
      {
        "name": "Mariam T.",
        "city": "Didube, Tbilisi",
        "pet": "Rich-i · Persian cat",
        "quote": "The SmartPaw feeder is the perfect solution for me \u2014 I travel often and Rich-i's meals are no longer something I worry about."
      },
      {
        "name": "Giorgi A.",
        "city": "Isani, Tbilisi",
        "pet": "Barry · Golden Retriever",
        "quote": "For years I had to hunt for products across different stores. With SmartPaw it's a completely new experience \u2014 no more pet-shop runs, no more shortage anxiety. I always have exactly what Barry needs."
      }
    ]
  },
  "signupLegacy": {
    "title": "Start your plan",
    "sub": "Tell us a little about you and your pet. We’ll be in touch within one business day to set up your delivery.",
    "name": "Your name",
    "email": "Email",
    "phone": "Phone",
    "petType": "Pet type",
    "petTypeOpts": {
      "dog": "Dog",
      "cat": "Cat",
      "both": "Both"
    },
    "petName": "Pet name (optional)",
    "petBreed": "Breed (optional)",
    "petAge": "Age (optional)",
    "notes": "Anything we should know? (optional)",
    "submit": "Send my details",
    "sending": "Sending…",
    "success": "Thanks! We’ll reach out within one business day.",
    "error": "Something went wrong. Please try again or message us on WhatsApp."
  },
  "footer": {
    "tagline": "Your pet's food, delivered on schedule.",
    "hours": "Mon-Sat · 09:00-19:00",
    "sections": {
      "company": "Company",
      "explore": "Explore",
      "contact": "Contact"
    },
    "company": [
      "About",
      "Blog",
      "Careers"
    ],
    "explore": [
      "Partner brands",
      "How it works",
      "Plans",
      "Special Offers"
    ],
    "legal": {
      "privacy": "Privacy",
      "terms": "Terms",
      "delivery": "Delivery",
      "refund": "Refund",
      "faq": "FAQ"
    },
    "address": "0102 Tsereteli Ave. 118, Tbilisi, Georgia",
    "rights": "All rights reserved."
  },
  "seo": {
    "home": {
      "title": "Smart pet food, delivered.",
      "description": "SmartPaw Food — a Tbilisi subscription that keeps your dog or cat’s shelf stocked. Vet-aligned brands, free SmartPaw Feeder, free door-to-door delivery."
    },
    "plans": {
      "title": "Plans & Pricing — three honest tiers in GEL",
      "description": "Three plans for Tbilisi pet parents. Free with delivery, 150 GEL/month with a free SmartPaw Feeder, or 15 GEL custom delivery. No minimums, no contracts."
    },
    "how": {
      "title": "How it works — sign up, sit back",
      "description": "The exact six-step workflow we run for every SmartPaw subscription in Tbilisi — from pet profile to door-to-door delivery."
    },
    "about": {
      "title": "About — Tbilisi-built, vet-aligned",
      "description": "SmartPaw Food is a Tbilisi-based subscription delivery service for dogs and cats. Meet the team, the values and the impact behind the box."
    },
    "contact": {
      "title": "Contact — talk to a real human",
      "description": "Get in touch with SmartPaw Food in Tbilisi. WhatsApp +995 591 96 99 01, guga@smartpaw.ge, or pick a department and send a message."
    },
    "faq": {
      "title": "FAQ — answers in plain language",
      "description": "Quick answers about SmartPaw Food plans, deliveries, products and the SmartPaw Feeder. Search 23 questions or WhatsApp us in Tbilisi."
    },
    "blog": {
      "title": "From the journal",
      "description": "Short, practical reads on pet nutrition, routines and Tbilisi pet life — written for owners, reviewed by working vets."
    }
  },
  "pageShell": {
    "comingSoon": "Coming soon",
    "ctaTitle": "Ready to simplify your pet care?",
    "ctaStart": "Register",
    "ctaConsult": "Book Free Consultation"
  },
  "breadcrumbs": {
    "home": "Home",
    "labels": {
      "/catalogue": "Partner brands",
      "/catalogue/food": "Food",
      "/catalogue/hygiene": "Hygiene",
      "/catalogue/vitamins": "Vitamins & Additives",
      "/catalogue/accessories": "Accessories",
      "/catalogue/other": "Other",
      "/special-offers": "Special Offers",
      "/special-offers/toys-accessories": "Toys & Accessories",
      "/special-offers/innovation-tech": "Innovation & Tech",
      "/special-offers/services": "Services",
      "/how-it-works": "FAQ",
      "/plans": "Plans & Pricing",
      "/about": "About",
      "/blog": "Blog",
      "/contact": "Contact",
      "/faq": "FAQ",
      "/privacy": "Privacy Policy",
      "/terms": "Terms & Conditions",
      "/delivery-policy": "Delivery Policy",
      "/refund-policy": "Refund Policy"
    }
  },
  "catalogue": {
    "filters": {
      "title": "Filters",
      "showing": "Showing",
      "of": "of",
      "clearAll": "↺ Clear all filters",
      "price": "Price",
      "petType": "Pet type",
      "petTypeAll": "All",
      "petTypeDog": "Dogs",
      "petTypeCat": "Cats",
      "type": "Type",
      "lifeStage": "Life stage",
      "brand": "Brand",
      "weight": "Weight",
      "status": "Status",
      "featuredOnly": "Featured only",
      "searchBrand": "Search brand",
      "noBrandMatch": (q) => `No brand matches "${q}"`,
      "showAll": (n) => `Show all (${n}) ↓`,
      "collapse": "Collapse ↑",
      "closeFilters": "Close filters",
      "filtersButton": "Filters"
    },
    "sort": {
      "label": "Sort:",
      "featured": "Featured first",
      "priceAsc": "Price: low → high",
      "priceDesc": "Price: high → low",
      "alphaAsc": "A → Z",
      "alphaDesc": "Z → A"
    },
    "shelf": {
      "loading": "Loading the shelf…",
      "loadErrorTitle": "We couldn’t load this shelf just now.",
      "loadErrorBody": "Please refresh, or message us on WhatsApp — we’ll send you the list directly.",
      "emptyTitle": "This shelf is being stocked.",
      "emptyBody": "We’re finalising listings with our partner brands. Register interest and we’ll tailor your first box around your pet.",
      "noResultsTitle": "Nothing matches those filters.",
      "noResultsBody": "Try clearing a filter — or switch to ‘All’ pet types.",
      "products": "products",
      "searchPlaceholder": "Search…"
    },
    "lifeStages": {
      "puppy": "Puppy",
      "junior": "Junior",
      "adult": "Adult",
      "senior": "Senior",
      "kitten": "Kitten",
      "cat": "Cat"
    },
    "productTypes": {
      "dry-food": "Dry food",
      "wet-food": "Wet food",
      "snacks": "Snacks",
      "teeth-care": "Teeth care",
      "grooming": "Grooming",
      "pads": "Pads",
      "other": "Other"
    }
  }
},
  ka: {
  "nav": {
    "home": "მთავარი",
    "catalogue": "პარტნიორი ბრენდები",
    "specials": "შეთავაზებები",
    "plans": "პაკეტები",
    "how": "FAQ",
    "blog": "ბლოგი",
    "about": "ჩვენ შესახებ",
    "faq": "FAQ",
    "contact": "კონტაქტი",
    "cta": "რეგისტრაცია",
    "consult": "უფასო კონსულტაცია",
    "simple": {
      "aboutUs": "ჩვენ შესახებ",
      "how": "როგორ მუშაობს",
      "register": "რეგისტრაცია",
      "consult": "კონსულტაცია",
      "brands": "პარტნიორი ბრენდები",
      "feeder": "SmartPaw Feeder",
      "experts": "ჩვენი ექსპერტები",
      "contact": "კონტაქტი",
      "home": "მთავარი",
      "menu": "მენიუ",
      "closeMenu": "დახურვა",
      "scrollDown": "გაიცანი მეტი"
    }
  },
  "common": {
    "startPlan": "დაიწყე უფასოდ",
    "talkToUs": "დაგვიკავშირდი",
    "openWhatsApp": "WhatsApp-ის გახსნა",
    "askWhatsApp": "მოგვწერე WhatsApp-ში",
    "chatWhatsApp": "მოგვწერე WhatsApp-ში",
    "stillStuck": "პასუხი ვერ იპოვე? მოგვწერე WhatsApp-ში",
    "read": "წაიკითხე",
    "readMore": "წაიკითხე მეტი",
    "loading": "იტვირთება…",
    "tryAgain": "თავიდან სცადეთ",
    "backToBlog": "უკან ბლოგზე",
    "sending": "იგზავნება…",
    "yes": "კი",
    "no": "არა",
    "included": "მოიცავს",
    "notIncluded": "არ მოიცავს",
    "new": "ახალი"
  },
  "hero": {
    "eyebrow": "თბილისში · უფასო მიწოდება",
    "titleA": "მიიღე ბევრად მეტი —",
    "titleB": "მხოლოდ პროდუქტის ფასად.",
    "sub": "დარეგისტრირდი და გაერთე შენს ოთხფეხა მეგობართან ერთად — დანარჩენზე SmartPaw იზრუნებს.",
    "ctaPrimary": "რეგისტრაცია",
    "ctaConsult": "დაჯავშნე კონსულტაცია",
    "ctaWhatsapp": "მოგვწერე WhatsApp-ზე",
    "ctaSecondary": "პარტნიორი ბრენდები",
    "ctaSpecials": "შეთავაზებები",
    "stat1": "უფასო მიწოდება ნებისმიერი რაოდენობისთვის",
    "stat2": "ინდივიდუალური კონსულტაცია ჩვენი ექსპერტებისგან",
    "stat3": "არანაირი დეფიციტი",
    "stat4": "არასდროს დაგავიწყდება",
    "feederLine": "",
    "feederBadge": "SmartPaw ფიდერი"
  },
  "consult": {
    "title": "დაჯავშნე კონსულტაცია",
    "subtitle": "დატოვე სახელი და ტელეფონი — SmartPaw-ს ექსპერტი დაგიკავშირდება.",
    "name": "სახელი",
    "phone": "ტელეფონი",
    "time": "სასურველი დრო (სურვილისამებრ)",
    "timePlaceholder": "მაგ. ორშ-პარ 18:00-20:00",
    "note": "რისი განხილვა გსურს?",
    "submit": "მოითხოვე ზარი",
    "cancel": "გაუქმება",
    "thanksTitle": "მივიღეთ!",
    "thanksBody": "სამუშაო საათებში დაგიკავშირდებით."
  },
  "aboutUs": {
    "eyebrow": "ჩვენ შესახებ",
    "title": "შექმნილია თბილისში, ცხოველების მფლობელების მიერ.",
    "body": "SmartPaw-ი დაიბადა მარტივი იმედგაცრუებიდან — გვიანი რბოლები ზოომაღაზიებში, დავიწყებული საჭმლის ტომრები და ფიდერები, რომლებიც რეალურ გრაფიკს არ ერგება. ჩვენ ვათავსებთ ვეტერინარების მიერ დამტკიცებულ ბრენდებს ჭკვიან ფიდერთან და კარამდე მიწოდებასთან, რათა შენი ცხოველის რუტინა თავისთავად მუშაობდეს.",
    "teamTitle": "ხალხი, ვინც SmartPaw-ს ქმნის"
  },
  "consultSection": {
    "eyebrow": "უფასო კონსულტაცია",
    "title": "არ ხარ დარწმუნებული, რომელი პაკეტი ან ბრენდი შეარჩიო?",
    "body": "დაჯავშნე 15-წუთიანი უფასო ზარი SmartPaw-ის ექსპერტთან. დაგეხმარებით შეარჩიო სწორი საკვები, პორცია და გრაფიკი — ვალდებულების გარეშე.",
    "cta": "დაჯავშნე უფასო კონსულტაცია"
  },
  "feeder": {
    "eyebrow": "",
    "title": "მოწყობილობა, რომელიც სისტემურ კვებაში გეხმარება, მაშინაც კი — როდესაც სახლში არ ხარ.",
    "lead": "ერთად ვაპროგრამებთ კონკრეტულ დროებზე და რაოდენობებზე და ფიდერი კვებავს თქვენს ოთხფეხას, მაშინაც კი როდესაც სახლში არ ხართ.",
    "bullet1": "ავტომატური პორციები შენი არჩეული გრაფიკით",
    "bullet2": "მუშაობს როგორც დენის წყაროზე, ასევე — ელემენტებზე",
    "bullet3": "წყნარი, ცხოველისთვის უსაფრთხო მექანიზმი",
    "bullet4": "ჩვენ ვაპროგრამებთ, ვამარაგებთ საკვებით და ვუზრუნველყოფთ ტექნიკურ გამართულობას.",
    "cta": "დაჯავშნე კონსულტაცია"
  },
  "experts": {
    "eyebrow": "",
    "title": "ინდივიდუალური კონსულტაციები ყველა სმართფოელს.",
    "name": "გიორგი კობახიძე",
    "role": "კინოლოგი · კვების ექსპერტი",
    "bio": "კინოლოგი და ცხოველების მოვლის ექსპერტი, რომელსაც კვების სფეროში მრავალწლიანი პრაქტიკული გამოცდილება აქვს. გიორგი ეხმარება SmartPaw-ის მომხმარებლებს სწორი საკვების არჩევაში, პორციების განსაზღვრაში, ალერგიების მართვაში და რუტინის დახვეწაში.",
    "benefitsTitle": "რას იღებს ყოველი SmartPaw-ის მომხმარებელი:",
    "bullet1": "რეგულარული, უფასო კონსულტაცია",
    "bullet2": "ინდივიდუალური რჩევა საკვებზე და პორციებზე",
    "bullet3": "თქვენს ოთხფეხაზე მორგებული რჩევები მოვლის და ქცევის მიმართულებით",
    "bullet4": "გრაფიკის კორექტირება ცხოველის ზრდის მიხედვით",
    "cta": "დაჯავშნე უფასო კონსულტაცია"
  },
  "signup": {
    "title": "დაიწყე SmartPaw-თან",
    "subtitle": "შეავსე მოკლე ფორმა და ჩვენი მენეჯერი დაგიკავშირდება რეგისტრაციის დასასრულებლად.",
    "nameLabel": "სახელი",
    "surnameLabel": "გვარი",
    "phoneLabel": "ტელეფონის ნომერი",
    "addressLabel": "მისამართი",
    "petTypeLabel": "ცხოველის ტიპი",
    "petNameLabel": "ცხოველის სახელი",
    "petTypeDog": "ძაღლი",
    "petTypeCat": "კატა",
    "petTypeOther": "სხვა",
    "namePh": "მაგ. ნინო",
    "surnamePh": "მაგ. ბერიძე",
    "phonePh": "+995 ...",
    "addressPh": "ქალაქი, ქუჩა, ბინა",
    "petNamePh": "მაგ. სიმბა",
    "submit": "გაგზავნა",
    "sending": "იგზავნება...",
    "errorRequired": "გთხოვთ შეავსოთ ყველა სავალდებულო ველი.",
    "errorNetwork": "დაფიქსირდა შეცდომა. გთხოვთ სცადოთ ხელახლა.",
    "thanksTitle": "თქვენი განაცხადი მიღებულია",
    "thanksBody": "ჩვენი მენეჯერი მალე დაგიკავშირდებათ რეგისტრაციის დასასრულებლად.",
    "thanksClose": "დახურვა"
  },
  "contactSection": {
    "eyebrow": "კონტაქტი",
    "title": "დაგვიკავშირდი.",
    "body": "WhatsApp ყველაზე სწრაფი გზაა. ელფოსტაც გამოდგება — სამუშაო დღეებში რამდენიმე საათში გიპასუხებთ.",
    "addressLabel": "მისამართი",
    "phoneLabel": "ტელეფონი / WhatsApp",
    "emailLabel": "ელფოსტა",
    "hoursLabel": "სამუშაო საათები",
    "waCta": "მოგვწერე WhatsApp-ზე"
  },
  "pricing": {
    "title": "პაკეტები",
    "col1Title": "პარტნიორი ბრენდები",
    "col1Price": "0 ₾",
    "col1Body": "მომსახურება და მიწოდება უფასოა. იხდი მხოლოდ პროდუქტში.",
    "col2Badge": "ყველაზე პოპულარული",
    "col2Title": "150 ₾+ თვეში",
    "col2Price": "+ ფიდერი უფასოდ",
    "col2Body": "მოტანა, დაყენება და დაპროგრამება ჩვენზეა.",
    "col3Title": "SmartPaw ფიდერი",
    "col3Price": "უფასოდ",
    "col3Body": "თვეში 150 ₾+ შეკვეთისას. მოტანა, დაყენება და გაუქმებისას უკან წაღება — ყველაფერი ჩვენზეა.",
    "col4Title": "სხვა ბრენდები",
    "col4Price": "15 ₾ / თვე",
    "col4Body": "თუ შენი პროდუქტი ჩვენს კატალოგში არაა.",
    "fullDetails": "სრული პირობები →"
  },
  "referrals": {
    "eyebrow": "მოიწვიე მეგობარი",
    "title": "გაუზიარე SmartPaw სხვა ოჯახს",
    "body": "მოიწვიე მეგობარი — როცა ის პირველ შეკვეთას გააფორმებს, თქვენ ორივე მიიღებთ 20 ₾ კრედიტს შემდეგ მიწოდებაზე.",
    "cta": "გააზიარე WhatsApp-ზე",
    "waText": "მიხარია SmartPaw-ს! ჩემი ცხოველის საკვებს ყოველთვიურად მომაქვთ გრაფიკით — იმავე ფასად, უფასო მიწოდებით. გაფიქრდი: https://smartpaw.ge"
  },
  "faq": {
    "eyebrow": "FAQ",
    "title": "ხშირად დასმული კითხვები",
    "seeMore": "ნახე მეტი",
    "seeLess": "ნახე ნაკლები",
    "items": [
      { "q": "როგორ მუშაობს გამოწერა?", "a": "ერთხელ არჩევ პროდუქტებს, აწესებ სიხშირეს (ყოველკვირა / 2 კვირაში / თვეში ერთხელ) — ჩვენ გრაფიკით მოგიტანთ. ნებისმიერ დროს შეგიძლია შეაჩერო ან შეცვალო." },
      { "q": "ფასები იგივეა, რაც ზოომაღაზიაში?", "a": "დიახ — იხდი იმავე ფასს, რაც ჩვენი პარტნიორი მაღაზიებში. მიწოდება ჩვენზეა." },
      { "q": "შეიძლება შევაჩერო ან გავაუქმო ნებისმიერ დროს?", "a": "რა თქმა უნდა — ცვლილებებს აკეთებ კაბინეტიდან. თუ გაქვს ფიდერი, უფასოდ გამოგართმევთ." },
      { "q": "რომელ უბნებს ფარავთ?", "a": "მთელი თბილისი. თუ თბილისის გარეთ ხარ — მოგვწერე WhatsApp-ზე, ვფართოვდებით." },
      { "q": "რა მოხდება, თუ ჩემი სასურველი ბრენდი არ გაქვთ?", "a": "შეგვიძლია თითქმის ნებისმიერი ბრენდის მოტანა თვეში 15 ₾ მომსახურების საფასურით. აღნიშნე ეს რეგისტრაციისას." },
      { "q": "როგორ მივიღო მხარდაჭერა?", "a": "მოგვწერე WhatsApp-ზე: +995 591 96 99 01. ვპასუხობთ 2 საათში, სამუშაო საათებში (ორშ-შაბ · 09:00-19:00)." }
    ]
  },
  "care": {
    "title": "SmartPaw Care: 8 კვების წერტილი თბილისის მიუსაფარი ცხოველებისთვის.",
    "link": "გაიგე მეტი ↗"
  },
  "ctaBand": {
    "question": "გინდა საერთოდ აღარ იარო ზოომაღაზიაში?",
    "cta": "დაიწყე უფასოდ"
  },
  "partners": {
    "eyebrow": "",
    "heading": "300+ ბრენდი გვენდობა",
    "viewAll": "ნახე ყველა ბრენდი"
  },
  "quote": {
    "eyebrow": "დაიწყე 1 წუთში",
    "title": "დაიწყე 1 წუთში",
    "subtitle": "დაგიკავშირდებით WhatsApp-ზე სამუშაო საათებში, 2 საათის განმავლობაში.",
    "bullet1": "უფასო მიწოდება",
    "bullet2": "შეაჩერე ან შეცვალე ნებისმიერ დროს",
    "bullet3": "120+ ოჯახი უკვე ჩვენთანაა",
    "name": "სახელი",
    "phone": "ტელეფონი",
    "email": "Email",
    "petType": "ცხოველი",
    "petName": "ცხოველის სახელი",
    "age": "ასაკი (წელი)",
    "weight": "წონა (კგ)",
    "breed": "ჯიში",
    "brand": "სასურველი ბრენდი",
    "city": "უბანი",
    "notes": "შენიშვნები",
    "moreDetails": "+ დაამატე დეტალები (სურვილისამებრ)",
    "submit": "გაგზავნა",
    "disclaimer": "პასუხს 2 საათში მიიღებთ (სამუშაო საათებში).",
    "thanksTitle": "მადლობა, {name}!",
    "thanksBody": "მალე მოგწერთ WhatsApp-ზე.",
    "thanksCta": "მოგვწერე ახლავე",
    "recommend": "არ ვიცი / მირჩიეთ"
  },
  "team": {
    "eyebrow": "ჩვენი გუნდი",
    "title": "ხალხი, ვინც SmartPaw-ს ქმნის",
    "subtitle": "პრაქტიკული გამოცდილება ცხოველთა მოვლაში, ბიზნესსა და ინოვაციაში."
  },
  "products": {
    "regular": {
      "eyebrow": "რას მოგიტანთ",
      "title": "რას მოგიტანთ",
      "body": "",
      "notice": "",
      "items": [
        {
          "key": "food",
          "title": "საკვები",
          "desc": "მშრალი საკვები, სველი საკვები, ხემსები"
        },
        {
          "key": "hygiene",
          "title": "ჰიგიენა",
          "desc": "შამპუნი, ქვიშა, ხელსახოცები და გრუმინგის საშუალებები."
        },
        {
          "key": "vitamins",
          "title": "ვიტამინები და დანამატები",
          "desc": "ვიტამინები, პრობიოტიკები და დიეტური დანამატები."
        }
      ]
    },
    "specials": {
      "eyebrow": "შეთავაზებები",
      "title": "",
      "body": "მიიღე სპეციალური ფასები და პირობები ჩვენი პარტნიორებისგან.",
      "notice": "",
      "items": [
        {
          "key": "toys",
          "title": "სათამაშოები და აქსესუარები",
          "desc": "საყელოები, საბმელები, საწოლები, სათამაშოები და სეზონური შეთავაზებები."
        },
        {
          "key": "tech",
          "title": "ინოვაცია და ტექნოლოგია",
          "desc": "ჭკვიანი ფიდერები, paw-cam - ები და ციფრული მოწყობილობები."
        },
        {
          "key": "services",
          "title": "სერვისები",
          "desc": "გრუმინგი, სასტუმროები, ბაღები და სხვა"
        }
      ]
    }
  },
  "features": {
    "f1": {
      "kicker": "ვეტერინარების შერჩეული ბრენდები",
      "title": "თარო, რომელიც შინაური ცხოველის რეგულარული პროდუქტებით ავტომატურად ივსება ექსპერტების მიერ. ",
      "body": "პრემიუმ კლასის ძაღლის და კატის საკვები, ხემსები, ვიტამინები. დატოვე ის, რაც გიყვარს, შეცვალე ის, რაც არ მუშაობს — ჩვენ მოგამარაგებთ ავტომატურად, თქვენზე მორგებული გრაფიკით.",
      "cta": "დაათვალიერე კატალოგი"
    },
    "f2": {
      "kicker": "კარიდან კარამდე მიწოდება",
      "title": "ჩვენ ვგეგმავთ მიწოდებებს. თქვენ ისვენებთ. ",
      "body": "უფასო კარამდე მოწოდება თბილისის და შემოგარენის მასშტაბით, არანაირი მინიმალური შეკვეთა, იგივე ფასები რაც მაღაზიაში, არანაირი ზედმეტი ხარჯი. შუადღემდე გაფორმებული შეკვეთების იმავე დღეს მოწოდება. ",
      "cta": "დაგვიკავშირდი"
    },
    "f3": {
      "kicker": "მორგებული შენს ოთხფეხაზე",
      "title": "სპეციალურად შენი ძაღლისთვის ან/და კატისთვის აწყობილი გეგმა — არანაირი შაბლონი.",
      "body": "ერთხელ გვითხარი შენი ცხოველის ჯიში, ასაკი და კვების ჩვევები. ჩვენ ვარეგულირებთ მოწოდების ზომას, სიხშირეს და რიტმს, რომ მომდევნო შეკვეთა იყოს ზუსტი და დროული.",
      "cta": "წაიკითხე ბლოგი"
    },
    "f4": {
      "kicker": "ძაღლები + კატები — ერთად",
      "title": "ცხოვრების ნებისმიერი ეტაპი, ნებისმიერი დიეტა.",
      "body": "ხანდაზმული ცხოველის ფორმულა, ლეკვის ან კნუტის სტარტერ-პაკეტი, მგრძნობიარე კუჭის სერია, ჰიპოალერგენული ვარიანტები — ძაღლებსაც და კატებსაც. გეგმა იზრდება შენს ცხოველთან ერთად.",
      "cta": "ღია მაღაზია"
    }
  },
  "why": {
    "eyebrow": "რატომ SmartPaw",
    "title": "რუტინული კვების მნიშვნელობა",
    "body": "წამყვანი ვეტერინარული ორგანიზაციები ერთხმად აღნიშნავენ: რუტინული კვება პრევენციული მოვლის ერთ-ერთი ფუნდამენტური ნაწილია. AAHA (American Animal Hospital Association)-ის რეკომენდაციით, კვების სიხშირე, დრო და პორცია უნდა შეფასდეს ვეტერინართან ყოველი ვიზიტისას, რადგან თანმიმდევრული კვება ხელს უწყობს კალორიების კონტროლს, ჯანმრთელი წონის შენარჩუნებას და მადის ცვლილების დროულად შემჩნევას — რაც, ხშირ შემთხვევაში, დაავადების პირველი ნიშანია.",
    "bodyCite": "წყარო: AAHA Nutrition & Weight Management Guidelines (2021).",
    "badges": [
      "უფასო რეგულარული მიწოდება",
      "უფასო ფიდერი",
      "რეგულარული შეხსენებები",
      "მორგებული შენს ოთხფეხაზე - არანაირი შაბლონი"
    ]
  },
  "how": {
    "eyebrow": "როგორ მუშაობს",
    "title": "როგორ მუშაობს",
    "body": "",
    "cta": "დარეგისტრირდი",
    "steps": [
      { "n": "01", "t": "დააჭირე რეგისტრაციას", "d": "შეავსე მარტივი ფორმა." },
      { "n": "02", "t": "მოგვიყევი შენს ოთხფეხაზე", "d": "სახეობა, ასაკი, წონა — და ყველაფერი, რაც უნდა ვიცოდეთ." },
      { "n": "03", "t": "აირჩიე პროდუქტები, რაოდენობა და სიხშირე", "d": "300+ ბრენდიდან, ან გირჩევთ ჩვენ." },
      { "n": "04", "t": "დაისვენე — დანარჩენი ჩვენზეა", "d": "ვაკვირდებით მოხმარებას და მოგიტანთ სანამ ამოგეწურება — დროულად, ყოველთვის." }
    ]
  },
  "howPage": {
    "timelineEyebrow": "ნაბიჯ-ნაბიჯ",
    "timelineTitle": "რა ხდება რეგისტრაციიდან მეორე მიწოდებამდე.",
    "timelineIntro": "SmartPaw ცხოველის მფლობელების რეალური საჭიროებებიდან გამომდინარე შეიქმნა: ხშირი ვიზიტები ზოომაღაზიებში, ხშირი „დეფიციტები\", ბევრი უხარისხო ფიდერი, რომელიც რუტინას აზიანებს. ჩვენი სამუშაო არის გამჭირვალე, მომხმარებელზე ორიენტირებული, პატიოსანი და ადამიანური.",
    "timeline": [
      {
        "title": "მოგვიყევი შენი ცხოველის შესახებ",
        "body": "2-წუთიანი ფორმა: სახეობა, ჯიში, ასაკი, წონა, მგრძნობელობა და დღევანდელი რუტინა. ამის მიხედვით ვადგენთ პორციას და წინასწარ ვირჩევთ შენთვის შესაფერის პროდუქტების პაკეტს.",
        "bullets": [
          "ცხოველის პროფილი + ფოტო (არასავალდებულო)",
          "დიეტური შენიშვნები და ალერგიები",
          "შენი უბანი თბილისში"
        ]
      },
      {
        "title": "ჩვენ ვმართავთ თქვენს თაროს",
        "body": "ჩვენი გუნდი არჩევს პროდუქტებს შენი პროფილის და ვეტერინარების რეკომენდაციის მიხედვით. შენ ზუსტად ხედავ რა შედის პაკეტში — შეცვალე ან დაამატე ნებისმიერი პროდუქტი, ნებისმიერ დროს.",
        "bullets": [
          "ვეტ-რეკომენდირებული ბრენდის შესაბამისობა",
          "საკვები + ჰიგიენა + ხემსების ნაკრები",
          "შენ ადასტურებ პირველი მიწოდების წინ"
        ]
      },
      {
        "title": "აირჩიე სიხშირე",
        "body": "კვირაში ერთხელ, ორ კვირაში ერთხელ, ან თვეში ერთხელ. აირჩიე მიწოდების სასურველი გრაფიკი — ჩვენ შეგახსენებთ და მოგამარაგებთ.",
        "bullets": [
          "კვირაში ერთხელ, ორ კვირაში ერთხელ, ან თვეში ერთხელ.",
          "აირჩიე 2-საათიანი მიწოდების ფანჯარა",
          "შეჩერება ან გამოტოვება ნებისმიერ დროს"
        ]
      },
      {
        "title": "სახლში მოწოდება",
        "body": "ერთი და იგივე კურიერი — რომ შენი ძაღლი ზარს აღარ უყეფდეს. დადასტურებული ქვითარი და WhatsApp შეტყობინება მოსვლამდე ერთი საათით ადრე.",
        "bullets": [
          "უფასო მიწოდება ნებისმიერი ოდენობით, ნებისმიერი პროდუქტი",
          "წინასწარი შეტყობინება WhatsApp - ზე",
          "სურვილისამებრ — დაგიტოვებთ კართან"
        ]
      },
      {
        "title": "შეცვალე ნებისმიერ დროს",
        "body": "ცხოველი ახალ დიეტაზე გადადის? მოგზაურობ? უბრალოდ გვითხარი. გამოტოვე მიწოდება, შეცვალე ბრენდი, შეცვალე სიხშირე — ზედმეტი ხარჯის და სტრესის გარეშე.",
        "bullets": [
          "ბრენდის შეცვლა, დამატებითი ხარჯის გარეშე",
          "შეჩერება/გამოტოვება WhatsApp-დან",
          "პროფილის განახლება ნებისმიერ დროს"
        ]
      },
      {
        "title": "გუნდი, რომელიც ნამდვილად პასუხობს",
        "body": "მეორე მხარეს — ცოცხალი ადამიანი. ჩვენ ვპასუხობთ WhatsApp-ში სამუშაო საათებში და მეორე შეტყობინებიდან შენს ცხოველს სახელით ვიცნობთ.",
        "bullets": [
          "WhatsApp — და არა ჩატბოტი",
          "ადგილობრივი გუნდი თბილისში",
          "საშუალო პასუხის დრო — 1 საათი"
        ]
      }
    ],
    "faqEyebrow": "სწრაფი პასუხები",
    "faqTitle": "სანამ დარეგისტრირდები.",
    "faqs": [
      {
        "q": "რამდენ ხანს გრძელდება რეგისტრაცია?",
        "a": "დაახლოებით ორ წუთს. მოგვიყევი ცხოველის შესახებ, აირჩიე სიხშირე — ჩვენ ჩვეულებრივ ერთ საათში გიგზავნით ინდივიდუალურ შეთავაზებას WhatsApp-ში."
      },
      {
        "q": "უნდა გავაფორმო კონტრაქტი?",
        "a": "არა. ყველა პაკეტი ყოველთვიური განახლების სისტემით მუშაობს. შეჩერება, გამოტოვება ან გაუქმება — ნებისმიერ დროს, კითხვების და გასვლის საფასურის გარეშე."
      },
      {
        "q": "რა მოხდება, თუ ჩემს ცხოველს პროდუქცია არ მოეწონება?",
        "a": "მოგვწერე WhatsApp-ში და ჩვენ შემდეგ მიწოდებაში დამატებითი საფასურის გარეშე გადავცვლით. ვაკვირდებით რას მიირთმევს ცხოველი და დროთა განმავლობაში ვაუმჯობესებთ ასორტიმენტს."
      },
      {
        "q": "მიწოდება ნამდვილად უფასოა?",
        "a": "დიახ — ნებისმიერი პაკეტით, თბილისის ნებისმიერ რაიონში. მინიმალური შეკვეთის გადასახადი არ არსებობს და დამატებითი საფასური არ ერიცხება."
      },
      {
        "q": "შემიძლია მხოლოდ ფიდერი ავიღო, ყუთის გარეშე?",
        "a": "ფიდერი 150 ლარიანი თვიური პაკეტის ნაწილია — დეტალები იხილე Plans გვერდზე. პაკეტის გააქტიურების შემდეგ ფიდერი უფასოდ მოგეწოდება."
      }
    ]
  },
  "plans": {
    "eyebrow": "პაკეტები და ფასები",
    "title": "სამი პაკეტი. აირჩიე შენი რუტინა.",
    "intro": "ინდივიდუალური ნაკრებები. დაიწყე მხოლოდ უფასო მომარაგებით, ან აიღე SmartPaw ფიდერი უფასოდ 150-ლარიანი თვიური პაკეტის ფარგლებში, ან მოაწყვე შენზე მორგებული თარო 15-ლარიანი ფიქსირებული მიწოდების საფასურით.",
    "badgePopular": "ყველაზე პოპულარული",
    "pricePer": "/ თვეში",
    "flatFee": "ფიქსირებული ფასი მიწოდებაზე",
    "pickThis": "მოცემული გეგმის არჩევა",
    "pickFeeder": "ფიდერ-პაკეტის არჩევა",
    "customPlan": "ინდივიდუალური გეგმის შექმნა",
    "inclEyebrow": "რა შედის",
    "everythingIn": "ყველაფერი, რაც შედის:",
    "tiers": [
      {
        "key": "უფასო",
        "eyebrow": "სტარტი",
        "name": "SmartPaw უფასო",
        "price": "0 ლარი",
        "priceNote": "იხდი მხოლოდ პროდუქტების საფასურს.",
        "tagline": "საცდელად, ყველანაირი ვალდებულების გარეშე. ",
        "features": [
          "უფასო მიწოდება თბილისში",
          "შეხსენებები შევსებებსა და განახლებებზე",
          "მინიმალური შეკვეთის გარეშე, კონტრაქტის გარეშე",
          "შეჩერება, გამოტოვება ან გაუქმება ნებისმიერ დროს"
        ],
        "cta": "დაიწყე უფასოდ"
      },
      {
        "key": "ფიდერი",
        "eyebrow": "საუკეთესო ღირებულება",
        "name": "უფასო + SmartPaw ფიდერი",
        "price": "150 ლარი",
        "priceNote": "მინიმალური თვიური ხარჯი.",
        "tagline": "რუტინა ავტოპილოტზე — ფიდერი მოყვება.",
        "features": [
          "ყველაფერი, რაც SmartPaw უფასოში",
          "უფასო SmartPaw ჭკვიანი ფიდერი (ღირებულება ~300 ლარი)",
          "ავტომატური პორციები, მაშინაც, როცა შინ არ ხარ",
          "პრიორიტეტული SmartPaw ექსპერტის კონსულტაცია"
        ],
        "cta": "ფიდერის მიღება"
      },
      {
        "key": "შენზე მორგებული",
        "eyebrow": "მიწოდებაზე გადახდა",
        "name": "ინდივიდუალური მიწოდება",
        "price": "15 ლარი",
        "priceNote": "ფიქსირებული ფასი მიწოდებაზე — სააბონენტოს გარეშე.",
        "tagline": "ერთჯერადი ან გრაფიკის გარეთ შეკვეთა გჭირდება?",
        "features": [
          "თვიური მინიმუმის გარეშე",
          "შეუკვეთე ზუსტად ის, რაც გჭირდება, მაშინ, როცა გჭირდება",
          "იმავე დღეს, თუ შეკვეთა შუადღემდე განთავსდება",
          "პაკეტის შეცვლა ნებისმიერ დროს"
        ],
        "cta": "ინდივიდუალური შეკვეთა"
      }
    ],
    "compareEyebrow": "გვერდიგვერდ",
    "compareTitle": "შეადარე სამივე პაკეტი.",
    "compareFeatureCol": "მახასიათებელი",
    "compareRows": [
      {
        "feature": "უფასო მიწოდება თბილისში",
        "values": [
          "მართალი",
          "მართალი",
          "15 ლარი ფიქს."
        ]
      },
      {
        "feature": "თვიური მინიმუმი",
        "values": [
          "არ არის",
          "150 ლარი",
          "არ არის"
        ]
      },
      {
        "feature": "უფასო SmartPaw ფიდერი",
        "values": [
          "სიცრუე",
          "მართალი",
          "სიცრუე"
        ]
      },
      {
        "feature": "შევსების შეხსენებები",
        "values": [
          "მართალი",
          "მართალი",
          "მართალი"
        ]
      },
      {
        "feature": "ბრენდის შეცვლა მოთხოვნით",
        "values": [
          "მართალი",
          "მართალი",
          "მართალი"
        ]
      },
      {
        "feature": "პრიორიტეტული SmartPaw ექსპერტის კონსულტაცია",
        "values": [
          "სიცრუე",
          "მართალი",
          "სიცრუე"
        ]
      },
      {
        "feature": "შეჩერება, გამოტოვება, გაუქმება",
        "values": [
          "მართალი",
          "მართალი",
          "—"
        ]
      },
      {
        "feature": "საუკეთესოა ",
        "values": [
          "პლატფორმის ცდისთვის",
          "გრძელვადიანი მოვლისთვის",
          "ერთჯერადი შეკვეთებისთვის"
        ]
      }
    ],
    "servicesEyebrow": "ხელმისაწვდომი ნებისმიერ პაკეტში",
    "servicesTitle": "დამატებითი სერვისები — ნებისმიერ პაკეტში.",
    "servicesBody": "ეს სერვისები ხელმისაწვდომია ნებისმიერი პაკეტის მფლობელისთვის. ვაკავშირებთ შენი მიწოდების გრაფიკთან და თანხას იხდით სერვისის მიღებისას — ზედმეტი ფასის გარეშე.",
    "servicesCta": "ნახე ყველა სერვისი",
    "services": [
      {
        "title": "გრუმინგი",
        "body": "დაბანა, დავარცხნა და ფრჩხილების მოვლა შერჩეული გრუმერისგან — სახლში მისვლით ან ჩვენი პარტნიორის ლოკაციაზე."
      },
      {
        "title": "ვეტერინარული შემოწმება",
        "body": "პერიოდული ვიზიტები ვეტერინართან. ვაქცინაციის შეხსენებები. "
      },
      {
        "title": "სახლში ვიზიტი",
        "body": "ცხოველის ძიძა, სანამ მოგზაურობ. სისტემური კვება, რეგულარული გასეირნება და ფოტომასალის რეგულარული მოწოდება."
      }
    ],
    "footnote": "საბოლოო პირობები (მინიმალური თვიური ხარჯი, ფიდერის დაბრუნების პოლიტიკა და სერვისების ფასები) ფიქსირდება რეგისტრაციისას. გჭირდება ინდივიდუალური აწყობა? მოგვწერე WhatsApp-ში."
  },
  "about": {
    "eyebrow": "ჩვენ შესახებ",
    "title": "აკეთე სიკეთე სწორად",
    "intro": "SmartPaw დაარსდა ცხოველის მფლობელების მიერ, რომელთაც მობეზრდათ მაღაზიის ვიზიტები, დავიწყებული საკვების ბოლო წამს ყიდვით და რეალურ გრაფიკთან შეუთავსებელი ფიდერებით. ჩვენ ვაკავშირებთ პროდუქტებს უფასო SmartPaw ფიდერთან და კარამდე მიწოდებასთან — რომ რუტინამ თავად იმუშაოს.",
    "founderEyebrow": "დამფუძნებლის ისტორია",
    "founderTitle": "შექმნილია ცხოველის მფლობელებისთვის, ცხოველის მფლობელის მიერ.",
    "founderParas": [
      "SmartPaw-ი, როგორც ყველაფერი, რაც ნამდვილად გვჭირდება, პრობლემიდან დაიწყო, რომელსაც არავინ წყვეტდა ეფექტურად. ჩვენს დამფუძნებელს, თორნიკეს, ორი ძაღლი ჰყავს — ბუბა და რუკა — და აქვს ჩვევა, ხშირად სამშაბათს, საღამოს 10 საათზე გაიხსენოს, რომ საკვების ტომარა ცარიელია. ყოველ ჯერზე ერთიდაიგივე.",
      "მან გამოცადა ადგილობრივი მაღაზიები, იმპორტირებული ბრენდები და მსხვილი ქსელები. ბრენდები კარგი იყო. პრობლემა რუტინაში იყო. გვიან ღამე აღმოჩენა რომ საკვები არ არის, დავიწყება, ზედიზედ ორი კვირ \"დეფიციტი\", არაგამართული ფიდერები.",
      "ჩვენ შევქმენით ის, რაც გვჭირდებოდა. **რეგულარული სერვისი, სადაც ჩვენი საკვები უბრალოდ მოდის.** SmartPaw ფიდერი, რომელიც ავტომატურად ანაწილებს კვებას და რომლითაც უფასოდ სარგებლობ, გარკვეული პაკეტების ფარგლებში. მიწოდება, რომელიც ნამდვილად უფასოა — თბილისის ნებისმიერ უბანში და შემოგარენში. და გუნდი, რომელსაც WhatsApp-ში მიწერ ისე, როგორც მეგობარს."
    ],
    "founderQuote": "„თუ შენი ცხოველის ცხოვრებაში არის რუტინა, შენი ცხოვრება არ უნდა იგეგმებოდეს მის გარშემო.\"",
    "metrics": [
      {
        "value": "1 200+",
        "label": "ცხოველი იკვებება ყოველთვიურად"
      },
      {
        "value": "36",
        "label": "შერჩეული პროდუქტი თაროზე"
      },
      {
        "value": "< 60 წთ",
        "label": "WhatsApp საშუალო პასუხის დრო"
      },
      {
        "value": "0 ლარი",
        "label": "მიწოდების საფასური ნებისმიერ პაკეტზე"
      }
    ],
    "valuesEyebrow": "რას წარმოვადგენთ",
    "valuesTitle": "ოთხი რამ, რომელშიც კომპრომისზე არ მივდივართ.",
    "values": [
      {
        "title": "ვეტერინარის რჩევით",
        "body": "ჩვენთან ყველა პროდუქტი ისეთია, რასაც ვეტერინარი გირჩევდა — დიეტური ტრენდების გარეშე, ხრიკების გარეშე, „მარცვლეულის გარეშე რადგან კარგად ჟღერს\" — გარეშე."
      },
      {
        "title": "გულახდილი ფასი",
        "body": "არანაირი მინიმალური შეკვეთა, არანაირი მოწოდების ხარჯი, არანაირი ზედმეტი და დამალული ხარჯები. რომელ ფასადაც დარეგისტრირდები, იმავე ფასს ინარჩუნებ."
      },
      {
        "title": "თბილისური ფესვები",
        "body": "ადგილობრივად დაარსებული, ადგილობრივად მოწოდებული. ჩვენ ვპასუხობთ WhatsApp-ში, ვიცნობთ რაიონებს და მეორე შეტყობინებიდან შენი ძაღლის სახელით გვახსოვს."
      },
      {
        "title": "მშვიდად თანამედროვე",
        "body": "უფასო SmartPaw ფიდერი, თვით-მართვადი გრაფიკი და გუნდი, რომელიც ნამდვილად პასუხობს. იმდენად თანამედროვე, რომ უსაფრთხო იყოს, და იმდენად მშვიდი, რომ უხილავი დარჩეს."
      }
    ],
    "teamEyebrow": "გუნდი",
    "teamTitle": "მცირე გუნდი. დიდი თანმიმდევრულობით.",
    "teamIntro": "ოთხი ადამიანი არჩევს პროდუქტებს, მართავს მიწოდებებს, გპასუხობთ მესიჯებზე. არანაირი შაბლონური ტექსტები - უბრალოდ შინაური ცხოველების ექსპერტების გუნდი. ",
    "team": [
      {
        "name": "თორნიკე კ.",
        "role": "დამფუძნებელი და რუტინის დიზაინერი",
        "bio": "10 წლიანი გამოცდილება პროდუქტების განვითარებაში და ორი ძაღლი. SmartPaw - ს შექმნა გადაწყვიტა მას შემდეგ, რაც მობეზრდა მაღაზიებში სიარული და სტრესი. "
      },
      {
        "name": "ნინა გ.",
        "role": "ვეტერინარებთან თანამშრომლობის მენეჯერი",
        "bio": "ექთანი, რომელიც პროდუქტების მენეჯერი გახდა. ამოწმებს ყველა გზავნილს გამოშვებამდე და ხელმძღვანელობს საკონსულტაციო მიმართულებას. "
      },
      {
        "name": "ლუკა ბ.",
        "role": "ოპერაციები და მიწოდების ჯაჭვი",
        "bio": "თბილისის ყველა უბანს ხასიათით იცნობს. თუ ოდესმე საბურთალოზე გიცხოვრია, უნდა გესმოდეს ამ უბნის ფასეულობები."
      },
      {
        "name": "მარიამ ტ.",
        "role": "მომხმარებელზე ზრუნვა · კომუნიკაციის მენეჯერი",
        "bio": "ხმა, რომელიც შენი WhatsApp-ის მეორე მხარესაა. სახელით იცნობს SmartPaw - ს ცხოველებს და მათ პატრონებს და ზუსტად იცის ვის როდის უნდა გაუგზავნოს შეხსენება. "
      }
    ],
    "midCtaEyebrow": "რუტინა აქედან იწყება",
    "midCtaTitle": "გინდა შეთავაზება, რომელიც შენი ცხოველის, შენი ლოკაციისა და შენი კვირის რიტმს ერგება?"
  },
  "contact": {
    "eyebrow": "კონტაქტი",
    "title": "მოდი, ცხოველის რუტინაზე ვისაუბროთ.",
    "intro": "",
    "address": "მისამართი",
    "addressValue": "0102 წერეთლის გამზ. 118, თბილისი, საქართველო",
    "phone": "ტელეფონი / WhatsApp",
    "email": "ელფოსტა",
    "hours": "სამუშაო საათები",
    "hoursValue": "ორშ-შაბ · 09:00–19:00",
    "hoursToConfirm": "(დასადასტურებელი)",
    "sendEyebrow": "შეტყობინების გაგზავნა",
    "sendTitle": "ყველაფრისთვის, რაც სწრაფი WhatsApp-ი არ არის.",
    "sendBody": "",
    "topicLabel": "თემა",
    "topicOther": "სხვა",
    "departments": [
      {
        "key": "ზოგადი",
        "title": "მომხმარებლის მხარდაჭერა",
        "body": "პაკეტთან დაკავშირებული შეკითხვები, მიწოდება, პროდუქტის შეცვლა, თანხის დაბრუნება."
      },
      {
        "key": "პარტნიორობა",
        "title": "ბრენდის პარტნიორობა",
        "body": "მოათავსე შენი ბრენდი SmartPaw-ის კატალოგში ან/და სპეციალურ შეთავაზებებში."
      },
      {
        "key": "პრესა",
        "title": "პრესა და მედია",
        "body": "ინტერვიუ, დამფუძნებლის ციტატა, პროდუქციის ფოტო."
      },
      {
        "key": "კარიერა",
        "title": "კარიერა",
        "body": "ღია ვაკანსიები მიწოდებაში, მომხმარებლის მოვლასა და ოპერაციებში."
      }
    ],
    "form": {
      "name": "შენი სახელი",
      "namePh": "ანა რამიშვილი",
      "email": "ელფოსტა",
      "emailPh": "you@example.com",
      "subject": "თემა",
      "subjectPh": "რის შესახებაა?",
      "message": "შეტყობინება",
      "messagePh": "მოგვიყევი რა გჭირდება — მეტი დეტალი, უფრო სწრაფი პასუხი.",
      "submit": "შეტყობინების გაგზავნა",
      "errorRequired": "გთხოვ, შეავსე ყველა ველი გაგზავნამდე.",
      "errorGeneric": "ვერ გავგზავნეთ — გთხოვ, სცადე WhatsApp-ით.",
      "success": "მივიღეთ — გიპასუხებთ ერთ სამუშაო დღეში ელფოსტით. სასწრაფო შემთხვევაში — მოგვწერე WhatsApp-ში.",
      "routedTo": "მისამართდება"
    }
  },
  "faq": {
    "eyebrow": "FAQ",
    "title": "პასუხები — გასაგებად.",
    "intro": "ყველაზე ხშირი კითხვები, რომელსაც ცხოველის მფლობელები გვისვამენ. ვერ ნახე შენი კითხვა? მოგვწერე WhatsApp-ში — ჩვეულებრივ ერთ საათში ვპასუხობთ.",
    "searchPh": "მოძებნე FAQ-ში…",
    "categories": [
      {
        "key": "ყველა",
        "label": "ყველა"
      },
      {
        "key": "პაკეტები",
        "label": "პაკეტები და ფასები"
      },
      {
        "key": "მიწოდება",
        "label": "მიწოდება"
      },
      {
        "key": "პროდუქტები",
        "label": "პროდუქტები და ბრენდები"
      },
      {
        "key": "ფიდერი",
        "label": "SmartPaw ფიდერი"
      },
      {
        "key": "ანგარიში",
        "label": "ანგარიში და მხარდაჭერა"
      }
    ],
    "items": [
      {
        "cat": "პაკეტები",
        "q": "როგორ მუშაობს SmartPaw-ის მომსახურება?",
        "a": "რეგისტრირდები, ირჩევ პროდუქტებს და მომარაგების სიხშირეს (ყოველკვირეული, ორ-კვირეული ან თვიური). ჩვენ რეგულარულად მოგიტანთ სახლში, თქვენზე მორგებული გრაფიკით. შეგიძლია შეაჩერო, გამოტოვო ან შეცვალო პაკეტი ნებისმიერ დროს."
      },
      {
        "cat": "პაკეტები",
        "q": "რა ღირს?",
        "a": "პაკეტი იწყება 0 ლარიდან თვეში (უფასო პაკეტი) და იზრდება 15 ლარამდე თვეში (ნებისმიერი პროდუქტი, რაც კატალოგში არ გვაქვს). ასევე, თუ თქვენი დანახარჯი 150 ლარია თვეში, უფასოდ გადმოგეცემათ ფიდერი. სრული დეტალები — პაკეტების გვერდზე."
      },
      {
        "cat": "პაკეტები",
        "q": "შემიძლია შევაჩერო ან გავაუქმო?",
        "a": "დიახ — ნებისმიერ დროს, კითხვის გარეშე. შეაჩერე შვებულებისთვის, გააუქმე გადასვლის შემთხვევაში. გრძელვადიანი კონტრაქტი არ არსებობს, გასვლის საფასური — ნული."
      },
      {
        "cat": "პაკეტები",
        "q": "არის თუ არა ფასდაკლება რამდენიმე ცხოველზე?",
        "a": "დიახ — რამდენიმე ცხოველის შემთხვევაში, ფასი დაითვლება ინდივიდუალურად. მოგვწერე WhatsApp-ში ცხოველების რაოდენობასა და პროფილებზე და გამოგიგზავნით შეთავაზებას."
      },
      {
        "cat": "პაკეტები",
        "q": "შემიძლია SmartPaw პაკეტი სხვას ვაჩუქო?",
        "a": "დიახ. შეგვიძლია წინასწარ შევიმუშავოთ პაკეტი საჩუქრად თქვენი მეგობრის, ან ახლობლის ცხოველისთვის — მოგვწერე WhatsApp-ში მიმღების ცხოველის პროფილით."
      },
      {
        "cat": "მიწოდება",
        "q": "სად აწვდით?",
        "a": "თბილისის ყველა უბანში და შემოგარენში. SmartPaw მალე საქართველოს ყველა წერტილში იქნება. დაგვიტოვე საკონტაქტო და მიიღე შეტყობინება, როდესაც ჩვენ შენს ლოკაციაზე ვიქნებით. "
      },
      {
        "cat": "მიწოდება",
        "q": "მიწოდება ნამდვილად უფასოა?",
        "a": "დიახ — ნებისმიერი პაკეტით, თბილისის ნებისმიერ რაიონში. მინიმალური შეკვეთის გადასახადი არ არსებობს და დამატებითი საფასური არ ერიცხება."
      },
      {
        "cat": "მიწოდება",
        "q": "როგორ გავიგებ, როდის წამოვიდა ჩემი შეკვეთა?",
        "a": "WhatsApp-ში მიიღებ შეტყობინებას ჩვენი კურიერის მოსვლამდე დაახლოებით ერთი საათით ადრე, მისი სახელითა და მოწოდების მიახლოვებითი დროით. ერთი და იგივე კურიერი, რომ შენი ცხოველი მშვიდად დარჩეს."
      },
      {
        "cat": "მიწოდება",
        "q": "რა მოხდება, თუ შინ არავინ იქნება?",
        "a": "რეგისტრაციისას აირჩიე 2-საათიანი მიწოდების ფანჯარა, ან გვითხარი, რომ შეკვეთა კართან დავტოვოთ — შენი არჩევანია."
      },
      {
        "cat": "მიწოდება",
        "q": "შემიძლია მიწოდების თარიღი შევცვალო?",
        "a": "დიახ. ნებისმიერი მიწოდების გამოტოვება, გადადება ან დაჩქარება შესაძლებელია WhatsApp-ით, მიწოდებამდე 24 საათით ადრე."
      },
      {
        "cat": "პროდუქტები",
        "q": "ბრენდები ვეტერინარის რეკომენდირებულია?",
        "a": "დიახ. ჩვენთან ყველა პროდუქტი ისეთია, რომელსაც ვეტერინარი დაგირჩევდა — დიეტური ტრენდების გარეშე, ხრიკების გარეშე. ჩვენი ვეტერინარული პარტნიორობის ხელმძღვანელი, ნინა, ამოწმებს ყოველი შეკვეთის შემადგენლობას მიწოდებამდე."
      },
      {
        "cat": "პროდუქტები",
        "q": "რა მოხდება, თუ ჩემს ცხოველს პროდუქტი არ მოეწონება?",
        "a": "გვითხარი და ჩვენ გადაგიცვლით შემდეგი მიწოდებისას, დამატებითი საფასურის გარეშე. ვაკვირდებით რას მიირთმევს ცხოველი და დროთა განმავლობაში ვაუმჯობესებთ ასორტიმენტს."
      },
      {
        "cat": "პროდუქტები",
        "q": "გაქვთ სამედიცინო დიეტა?",
        "a": "დიახ — თირკმლის, შარდსასქესო, წონის მართვის, მგრძნობელობისა და ჰიპოალერგენული სერიები სხვადასხვა ბრენდისგან. გაგვიზიარე ვეტერინარის რეცეპტი WhatsApp-ში — და ჩავამატებთ შენს პაკეტში."
      },
      {
        "cat": "პროდუქტები",
        "q": "მხოლოდ საკვებს ყიდით?",
        "a": "არა. გვაქვს ჰიგიენის საშუალებები, ვიტამინები, სათამაშოები, აქსესუარები და ტექნოლოგია. სპეციალური შეთავაზებების გვერდზე ნახავ სათამაშოების, ინოვაცია-ტექნოლოგიისა და სერვისების სრულ ასორტიმენტს."
      },
      {
        "cat": "პროდუქტები",
        "q": "საიდან მოდის თქვენი ბრენდები?",
        "a": "საკვებისა და ჰიგიენის ხაზების უმეტესობა მოიწოდება ოფიციალური ევროპული დისტრიბუტორებიდან (Royal Canin, Hill's, Acana, Orijen, Beaphar, Virbac). ტექნოლოგია და აქსესუარები — ავტორიზებული რეგიონული პარტნიორებიდან. ყველა პროდუქტი — შეფუთული, ვადიანი და ტემპერატურა-კონტროლირებად საწყობში დაცული."
      },
      {
        "cat": "ფიდერი",
        "q": "რა არის უფასო SmartPaw ფიდერი?",
        "a": "პროგრამირებადი ჭკვიანი ფიდერი, რომელიც ავტომატურად ანაწილებს კვებას. უფასოდ მოგეწოდება შესაბამისი პაკეტით (მინიმალური შესყიდვა — 150 ლარი თვეში) — შენთან რჩება, სანამ მომსახურება აქტიურია."
      },
      {
        "cat": "ფიდერი",
        "q": "ვინ აყენებს და აპროგრამებს ფიდერს?",
        "a": "სურვილისამებრ, ჩვენი წარმომადგენელი დააყენებს პირველი მიწოდებისას, ან თვითონ აყენებ დაახლოებით 5 წუთში — ყოველი ფიდერი ნაბიჯ-ნაბიჯ ინსტრუქციით მოდის."
      },
      {
        "cat": "ფიდერი",
        "q": "რა ხდება ფიდერთან დაკავშირებით, თუ გავაუქმე პაკეტი?",
        "a": "გაუქმებისას ფიდერს აბრუნებ. ჩვენ დავაორგანიზებთ უფასო მოტანას შენთვის მოსახერხებელ დღეს. გადასახადი არ ერიცხება, მიწოდების საფასური — არ ერიცხება."
      },
      {
        "cat": "ფიდერი",
        "q": "შემიძლია SmartPaw ფიდერი მთლიანად ვიყიდო?",
        "a": "ამჟამად ფიდერი მხოლოდ ერთი პაკეტის ნაწილია (მინიმალური შესყიდვა თვეში - 150 ლარი). შესაძლოა მოგვიანებით შემოგთავაზოთ პირდაპირი ყიდვის ვარიანტი — მოგვწერე, თუ გინდა სიაში მოხვედრა."
      },
      {
        "cat": "ანგარიში",
        "q": "როგორ განვაახლო ცხოველის პროფილი?",
        "a": "პროცესში ცვლილებების შეტანა ამჟამად შესაძლებელია WhatsApp, ან მეილის მეშვეობით. მალე გვექნება მომხმარებლის პირადი კაბინეტი. "
      },
      {
        "cat": "ანგარიში",
        "q": "საჭიროა ანგარიშის შექმნა?",
        "a": "არ არის საჭირო რეგისტრაცია ინფორმაციის ან შეთავაზების მისაღებად. სრულ თვით-მართვად მოდელზე გადავალთ ცოტა მოგვიანებით, კალათისა და გადახდის ჩაშენების შემდეგ."
      },
      {
        "cat": "ანგარიში",
        "q": "როგორ დავიბრუნო თანხა?",
        "a": "თუ რამე დაზიანებული ან ვადაგასული მოგეწოდათ, მოგვწერე WhatsApp-ში 2 დღის განმავლობაში ფოტოთი — ჩვენ უფასოდ შევცვლით ან გადავიხდით დაზიანებული პროდუქციის თანხას."
      },
      {
        "cat": "ანგარიში",
        "q": "რამდენ ხანში პასუხობთ WhatsApp-ში?",
        "a": "საშუალო პასუხის დრო — 60 წუთზე ნაკლები სამუშაო საათებში (ორშ-შაბ, 09:00–19:00). სამუშაო საათების გარეთ ვპასუხობთ მომდევნო დილით."
      }
    ],
    "emptyBody": "სცადე სხვა საკვანძო სიტყვა, შეცვალე კატეგორია ან მოგვწერე WhatsApp-ში."
  },
  "blogPage": {
    "eyebrow": "ჟურნალიდან",
    "title": "რეალური ზრუნვა, რეალური საკითხავი.",
    "intro": "მოკლე, პრაქტიკული საკითხავი ცხოველის კვებაზე, რუტინაზე და წვრილ რამეებზე, რომელიც დიდ განსხვავებას ქმნის. დაწერილია მფლობელებისთვის, შემოწმებულია მოქმედი ვეტერინარების მიერ.",
    "allArticles": "ყველა სტატია",
    "cardRead": "წაიკითხე",
    "loadError": "ვერ ჩაიტვირთა ჟურნალი.",
    "emptyTitlePre": "ვერ მოიძებნა ",
    "emptyTitlePost": "ჯერ.",
    "emptyBody": "აირჩიე სხვა თეგი — სხვა სტატიები გზაშია."
  },
  "blogPost": {
    "share": "გაზიარება",
    "tags": "თეგები",
    "relatedTitle": "განაგრძე კითხვა.",
    "ctaEyebrow": "SmartPaw კვება",
    "ctaTitle": "გინდა საერთოდ აღარ იარო ზოომაღაზიაში?",
    "loadError": "ვერ ჩაიტვირთა სტატია."
  },
  "categories": {
    "eyebrow": "რას ვაწვდით",
    "title": "ერთი მომსახურება, ყველა პროდუქტი.",
    "items": [
      {
        "title": "საკვები",
        "desc": "მშრალი კვება, სველი კვება, ხემსები."
      },
      {
        "title": "აქსესუარები",
        "desc": "საყელოები, საბმელები, საწოლები, სათამაშოები."
      },
      {
        "title": "ჯანმრთელობა და ჰიგიენა",
        "desc": "დანამატები, ქვიშა, შამპუნი."
      },
      {
        "title": "SmartPaw ინოვაცია",
        "desc": "ჭკვიანი დისპენსერი, paw-cam და სხვა."
      }
    ]
  },
  "blog": {
    "eyebrow": "ჟურნალიდან",
    "title": "მიიღე საჭირო ინფორმაცია საერთაშორისო და ადგილობრივი ექსპერტებისგან.",
    "readAll": "გაეცანი ბლოგს",
    "items": [
      {
        "tag": "ჭკვიანი ტექნიკა",
        "t": "რატომ არის რეგულარული კვება მნიშვნელოვანი — და როგორ გვეხმარება ჭკვიანი ფიდერი",
        "d": "რუტინა არ არის არჩევანი ცხოველის ჯანმრთელობისთვის. ნახე, როგორ ხსნის სტრესს პროგრამირებადი ფიდერი.",
        "read": "წაიკითხე მეტი"
      },
      {
        "tag": "კვება",
        "t": "საკვების შეცვლა — ყოველგვარი პრობლემის გარეშე",
        "d": "ვეტერინარის რეკომენდირებული 9-დღიანი გეგმა ცხოველის კუჭ-ნაწლავის გაღიზიანების გარეშე ახალ დიეტაზე გადასასვლელად.",
        "read": "წაიკითხე მეტი"
      },
      {
        "tag": "თბილისის ცხოვრება",
        "t": "შინაური კატის ჩექლისთი ბინაში მცხოვრებთათვის",
        "d": "ვერტიკალური ტერიტორია, ნელი ფიდერი და მცირე ყოველდღიური რიტუალები კატებისთვის, რომელიც ბინიდან არ გადის.",
        "read": "წაიკითხე მეტი"
      }
    ]
  },
  "testimonials": {
    "eyebrow": "",
    "title": "პატრონების საუკეთესო არჩევანი.",
    "subtitle": "ოთხი მოკლე ისტორია წევრებისგან, ვინც შეწყვიტა საკვებზე ფიქრი.",
    "items": [
      {
        "name": "ნინო კ.",
        "city": "ვაკე, თბილისი",
        "pet": "ლუნა · ბრიტანული კატა",
        "quote": "მიწოდება ყოველთვის დროზე მოდის — უკვე 4 თვეა საკვებზე არ ვფიქრობ."
      },
      {
        "name": "დათო მ.",
        "city": "საბურთალო, თბილისი",
        "pet": "რექსი · ლაბრადორი",
        "quote": "გიორგის კონსულტაცია ძალიან გვეხმარება. ჩვენი რექსი მუდმივად სწორ და კარგ წონაზეა."
      },
      {
        "name": "მარიამ ტ.",
        "city": "დიდუბე, თბილისი",
        "pet": "რიჩი · სპარსული კატა",
        "quote": "სმართფო ფიდერი იდეალური გადაწყვეტაა ჩემთვის. ხშირად მიწევს მოგზაურობა და რიჩის კვებაზე აღარ ვნერვიულობ."
      },
      {
        "name": "გიორგი ა.",
        "city": "ისანი, თბილისი",
        "pet": "ბარი · ოქროსფერი რეტრივერი",
        "quote": "წლებია მაღაზიებში მიწევს პროდუქტების ძებნა. სმართფოსთან ერთად, სრულიად ახალი გამოცდილება მივიღე — არანაირი ზოომაღაზია და დეფიციტზე ნერვიულობა. ყოველთვის მაქვს საჭირო პროდუქტები ჩემი ბარისთვის."
      }
    ]
  },
  "signupLegacy": {
    "title": "დარეგისტრირდი",
    "sub": "მოგვიყევი შენსა და შენი ცხოველის შესახებ. ერთ სამუშაო დღეში დაგიკავშირდებით მიწოდების მოსამზადებლად.",
    "name": "შენი სახელი",
    "email": "ელფოსტა",
    "phone": "ტელეფონი",
    "petType": "ცხოველის ტიპი",
    "petTypeOpts": {
      "dog": "ძაღლი",
      "cat": "კატა",
      "both": "ორივე"
    },
    "petName": "ცხოველის სახელი (არასავალდებულო)",
    "petBreed": "ჯიში (არასავალდებულო)",
    "petAge": "ასაკი (არასავალდებულო)",
    "notes": "რამე დამატებითი? (არასავალდებულო)",
    "submit": "მონაცემების გაგზავნა",
    "sending": "იგზავნება…",
    "success": "მადლობა! ერთ სამუშაო დღეში დაგიკავშირდებით.",
    "error": "რაღაც ვერ მოხერხდა. სცადე თავიდან ან მოგვწერე WhatsApp-ში."
  },
  "footer": {
    "tagline": "ცხოველის საკვები შენს კართან, რეგულარულად.",
    "hours": "ორშ-შაბ · 09:00-19:00",
    "sections": {
      "company": "კომპანია",
      "explore": "გამოიკვლიე",
      "contact": "კონტაქტი"
    },
    "company": [
      "ჩვენ შესახებ",
      "ბლოგი",
      "კარიერა"
    ],
    "explore": [
      "პარტნიორი ბრენდები",
      "როგორ მუშაობს",
      "პაკეტები",
      "შეთავაზებები"
    ],
    "legal": {
      "privacy": "კონფიდენციალურობა",
      "terms": "პირობები",
      "delivery": "მიწოდება",
      "refund": "დაბრუნება",
      "faq": "ხშირი კითხვები"
    },
    "address": "0102 წერეთლის გამზ. 118, თბილისი, საქართველო",
    "rights": "ყველა უფლება დაცულია."
  },
  "seo": {
    "home": {
      "title": "ჭკვიანი საკვები შენი ცხოველისთვის, შენი სახლის კართან.",
      "description": "SmartPaw Food — რეგულარული მომსახურება, რომელიც შენი ძაღლისა თუ კატის პროდუქტების თაროს მართავს. ვეტერინარის რეკომენდირებული ბრენდები, უფასო SmartPaw ფიდერი და უფასო მიწოდება სახლში."
    },
    "plans": {
      "title": "პაკეტები და ფასები — სამი გულახდილი ოფცია ლარში",
      "description": "სამი პაკეტი ცხოველის მფლობელებისთვის. უფასო მიწოდებით, უფასო SmartPaw ფიდერით (150 ლარი თვეში დანახარჯის შემთხვევაში), ან 15 ლარი ინდივიდუალურად შერჩეული პროდუქტებისთვის. მინიმუმის გარეშე, კონტრაქტის გარეშე."
    },
    "how": {
      "title": "როგორ მუშაობს — დარეგისტრირდი და დაისვენე",
      "description": "ექვს-საფეხურიანი პროცესი, რომელსაც SmartPaw-ის მომსახურება მოიცავს — ცხოველის შესწავლიდან რეგულარულ მიწოდებამდე."
    },
    "about": {
      "title": "ჩვენ შესახებ — შექმნილი საქართველოში, ვეტერინარების ზედამხედველობით. ",
      "description": "SmartPaw Food — საქართველოში დაარსებული რეგულარული მიწოდების სერვისი ძაღლებისა და კატებისთვის. გაიცანი გუნდი, ღირებულებები და გავლენა, რომელიც ყოველი მოწოდების უკან დგას."
    },
    "contact": {
      "title": "კონტაქტი — ცოცხალ ადამიანთან საუბარი",
      "description": "დაუკავშირდი SmartPaw Food-ს თბილისში. WhatsApp +995 591 96 99 01, guga@smartpaw.ge, ან აირჩიე განყოფილება და გამოგვიგზავნე შეტყობინება."
    },
    "faq": {
      "title": "FAQ — გასაგები პასუხები",
      "description": "სწრაფი პასუხები SmartPaw Food-ის პაკეტებზე, მიწოდებაზე, პროდუქციასა და SmartPaw ფიდერზე. აირჩიე 23 კითხვიდან ან მოგვწერე WhatsApp-ში."
    },
    "blog": {
      "title": "ჟურნალიდან",
      "description": "მოკლე, პრაქტიკული საკითხავი ცხოველის კვებაზე, რუტინაზე და თბილისის ოთხფეხების ცხოვრებაზე — დაწერილია მფლობელებისთვის, შემოწმებულია ვეტერინარების მიერ."
    }
  },
  "pageShell": {
    "comingSoon": "მალე ხელმისაწვდომი",
    "ctaTitle": "მზად ხარ გაიმარტივო საქმე?",
    "ctaStart": "რეგისტრაცია",
    "ctaConsult": "დაჯავშნე უფასო კონსულტაცია"
  },
  "breadcrumbs": {
    "home": "მთავარი",
    "labels": {
      "/catalogue": "პარტნიორი ბრენდები",
      "/catalogue/food": "საკვები",
      "/catalogue/hygiene": "ჰიგიენა",
      "/catalogue/vitamins": "ვიტამინები და დანამატები",
      "/catalogue/accessories": "აქსესუარები",
      "/catalogue/other": "სხვა",
      "/special-offers": "სპეციალური შეთავაზებები",
      "/special-offers/toys-accessories": "სათამაშოები და აქსესუარები",
      "/special-offers/innovation-tech": "ინოვაცია და ტექნოლოგია",
      "/special-offers/services": "სერვისები",
      "/how-it-works": "FAQ",
      "/plans": "გეგმები და ფასები",
      "/about": "ჩვენ შესახებ",
      "/blog": "ბლოგი",
      "/contact": "კონტაქტი",
      "/faq": "ხშირი კითხვები",
      "/privacy": "კონფიდენციალურობის პოლიტიკა",
      "/terms": "წესები და პირობები",
      "/delivery-policy": "მიწოდების პოლიტიკა",
      "/refund-policy": "დაბრუნების პოლიტიკა"
    }
  },
  "catalogue": {
    "filters": {
      "title": "ფილტრები",
      "showing": "ნაჩვენებია",
      "of": "-დან",
      "clearAll": "↺ ფილტრების გასუფთავება",
      "price": "ფასი",
      "petType": "ცხოველის ტიპი",
      "petTypeAll": "ყველა",
      "petTypeDog": "ძაღლები",
      "petTypeCat": "კატები",
      "type": "ტიპი",
      "lifeStage": "ცხოვრების ეტაპი",
      "brand": "ბრენდი",
      "weight": "წონა",
      "status": "სტატუსი",
      "featuredOnly": "მხოლოდ რჩეული",
      "searchBrand": "მოძებნე ბრენდი",
      "noBrandMatch": (q) => `ბრენდი ვერ მოიძებნა „${q}"-ისთვის`,
      "showAll": (n) => `ნახე ყველა (${n}) ↓`,
      "collapse": "დახურვა ↑",
      "closeFilters": "ფილტრების დახურვა",
      "filtersButton": "ფილტრები"
    },
    "sort": {
      "label": "სორტირება:",
      "featured": "რჩეული პირველი",
      "priceAsc": "ფასი: დაბლიდან მაღლა",
      "priceDesc": "ფასი: მაღლიდან დაბლა",
      "alphaAsc": "ა → ჰ",
      "alphaDesc": "ჰ → ა"
    },
    "shelf": {
      "loading": "თარო იტვირთება…",
      "loadErrorTitle": "თარო ვერ ჩაიტვირთა.",
      "loadErrorBody": "გთხოვ, განაახლე გვერდი, ან მოგვწერე WhatsApp-ში — ჩვენ პირდაპირ გამოგიგზავნით სიას.",
      "emptyTitle": "ეს თარო ივსება.",
      "emptyBody": "ჩვენ ვასრულებთ პოზიციების სიას პარტნიორ ბრენდებთან. დარეგისტრირდი — და შენი ცხოველის ირგვლივ ავაწყობთ პირველ ყუთს.",
      "noResultsTitle": "ფილტრებს არაფერი ემთხვევა.",
      "noResultsBody": "სცადე ფილტრის გასუფთავება — ან გადართე „ყველა\" ცხოველის ტიპზე.",
      "products": "პროდუქცია",
      "searchPlaceholder": "ძიება…"
    },
    "lifeStages": {
      "puppy": "ლეკვი",
      "junior": "მოზარდი",
      "adult": "ზრდასრული",
      "senior": "ხანდაზმული",
      "kitten": "კნუტი",
      "cat": "კატა"
    },
    "productTypes": {
      "dry-food": "მშრალი საკვები",
      "wet-food": "სველი საკვები",
      "snacks": "ხემსები",
      "teeth-care": "კბილების მოვლა",
      "grooming": "მოვლა",
      "pads": "ხელსახოცები",
      "other": "სხვა"
    }
  }
},
};

export const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'ka', label: 'KA' },
];
